/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ InitFunction; });

// CONCATENATED MODULE: ./src/js/src/r4q/apply-cart-page.js
function applyCartPage(shopData, BSS_BCP, quoteConfig, translations) {
    let options = {
        method: 'GET'
    };
    let style = document.createElement("style");
      let cssRule = document.createTextNode(`
          .cart__checkout-button.button.bss-b2b-customer-portal-btn-quote-default {
              margin-top: 0px;
          }
          @media only screen and (max-width: 750px) {
              .cart__checkout-button.button.bss-b2b-customer-portal-btn-quote-default {
                  margin-top: 1rem;
              }
            }
      `)
      style.appendChild(cssRule)
      document.head.appendChild(style)
    // auto install
    let BSSCheckoutBtnDefault = document.querySelectorAll(BSS_BCP.helper.CheckoutBtnDefaultQuery);

    let BSSBQuoteCheckoutBtn = null;
    if (BSSCheckoutBtnDefault.length) {
        for (let i = 0 ; i < BSSCheckoutBtnDefault.length; i++ ) {
            BSSBQuoteCheckoutBtn = document.createElement(BSSCheckoutBtnDefault[i].tagName)
            let btnText = document.createTextNode(translations.add_to_quote);
            let isCloneAddToQuote = true;
            if (!BSSCheckoutBtnDefault[i].className.includes("bss-b2b-customer-portal-nt-checkout-btn") && !BSSCheckoutBtnDefault[i].className.includes("bss-b2b-customer-portal-share-cart-btn")) {
                if ([1532].includes(BSS_BCP.storeId)) {
                    const oldBSSBQuoteCheckoutBtn = document.querySelector('[data-animation-state="open"] .bss-b2b-customer-portal-btn-quote-default');
                    if(oldBSSBQuoteCheckoutBtn){
                        isCloneAddToQuote = false;
                        BSSBQuoteCheckoutBtn = oldBSSBQuoteCheckoutBtn;
                    } 
                    BSSBQuoteCheckoutBtn.className = BSSCheckoutBtnDefault[i].className.replace("atc-button--checkout","") + ' bss-b2b-customer-portal-btn-quote-default';
                } else {
                    BSSBQuoteCheckoutBtn.className = BSSCheckoutBtnDefault[i].className + ' bss-b2b-customer-portal-btn-quote-default';
                }

                if(isCloneAddToQuote){
                    BSSBQuoteCheckoutBtn.value = "quote";
                    BSSBQuoteCheckoutBtn.id = 'bss-r4q-btn-' + i;
                    BSSBQuoteCheckoutBtn.type = 'button';
                    BSSBQuoteCheckoutBtn.appendChild(btnText);
                    BSSCheckoutBtnDefault[i].parentElement.appendChild(BSSBQuoteCheckoutBtn);
                }
                BSSBQuoteCheckoutBtn.onclick = function (event) {
                    event.preventDefault()
                    validateProductBeforeAddToQuote();
                }
            }
        }
    }

    // manual install
    let BSSCPCustomCheckoutBtn = document.querySelectorAll("span.bss-bcp-custom-quote-cart-btn") 
    if (BSSCPCustomCheckoutBtn.length) {
        for (let i = 0; i < BSSCPCustomCheckoutBtn.length; i++) {
            BSSCPCustomCheckoutBtn[i].type = 'button';
            BSSCPCustomCheckoutBtn[i].name = 'checkout';
            BSSCPCustomCheckoutBtn[i].innerHTML = translations.add_to_quote;
            BSSCPCustomCheckoutBtn[i].onclick = function () {
                validateProductBeforeAddToQuote();
            }
        }
    }

    // create modal quote warning
    let popupHtml = `
    <div class="popup popup-validate-product-quote" data-popup="popup-3">
    <div class="popup-inner">
        <h2 class="bss-quote-note">REQUEST FOR QUOTE NOTE</h2>
        <div class="popup-scroll">
            <span>
                <p class="invalid-quote-product">
                </p>
            </span>
            <span class="invalid-quote-product-message">
                <p>
                ${translations.error_message}
                </p>
            </span>
        </div>
        <p><a class="bss-view-to-quote" href="#">View quote cart</a></p>
        <a class="popup-close popup-validate-product-quote" data-popup-close="popup-3" href="#">x</a>
    </div>
    </div>
    `;
    window.document.body.insertAdjacentHTML('afterbegin', popupHtml);
    // 

    const handleAddToQuote = function (currentProduct, currentVariant, currentQuantity) {
        let currentVariantId = currentVariant.id ? currentVariant.id.toString() : null;
        let quoteCartStorage = window.localStorage.getItem("bssQuoteCart") ? JSON.parse(window.localStorage.getItem("bssQuoteCart")) : [];
        let listVariantStorage = window.localStorage.getItem("bssListVariantQuoteCart") ? JSON.parse(window.localStorage.getItem("bssListVariantQuoteCart")) : [];
        if (!window.localStorage.getItem("bssQuoteCart")) {
            window.localStorage.setItem("bssQuoteCart", '');
        }
        if (!window.localStorage.getItem("bssListVariantQuoteCart")) {
            window.localStorage.setItem("bssListVariantQuoteCart", '');
        }
        if (currentProduct && currentVariant && currentVariantId) {
            let cartItem = {};
            if (quoteCartStorage && quoteCartStorage.length && listVariantStorage && listVariantStorage.length) {
                if (!listVariantStorage.includes(currentVariantId)) {
                    listVariantStorage.push(currentVariantId);
                    cartItem = BSS_BCP.quote.renderQuoteCartItem(currentProduct, currentVariant, currentQuantity);
                    quoteCartStorage.push(cartItem);
                } else {
                    for (let i = 0; i < quoteCartStorage.length; i++) {
                        let cartItemQty = quoteCartStorage[i].quantity ? quoteCartStorage[i].quantity : 0;
                        if (quoteCartStorage[i].variantId == currentVariantId) {
                            quoteCartStorage[i].quantity = cartItemQty + 1;
                            break;
                        }
                    }
                }
            } else {
                cartItem = BSS_BCP.quote.renderQuoteCartItem(currentProduct, currentVariant, currentQuantity);
                listVariantStorage.push(currentVariantId);
                quoteCartStorage.push(cartItem);
            }
            window.localStorage.setItem("bssQuoteCart", JSON.stringify(quoteCartStorage));
            window.localStorage.setItem("bssListVariantQuoteCart", JSON.stringify(listVariantStorage));
        }
    };

    const validateProductBeforeAddToQuote = async () => {
        let url = "/cart.js";
        const cartData = await fetch(url, options)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("HTTP error, status = " + response.status);
                }
                let dataJSON_promise = response.json();
                return dataJSON_promise;
            })
            .catch(function (error) {
                console.log("error:", error); // eslint-disable-line
            })

        if (cartData.items && cartData.items.length > 0) {
            let handleUrls = [];
            let handles = [];
            let keyIdMap = new Map();
            let cartItemProductMap = new Map();
            let cartItemProductMapByKey = [];
            cartData.items.forEach(function(item) {
                let proId = item.product_id;
                if (handles.indexOf(proId) === -1) {
                    handles.push(proId);
                    handleUrls.push('id:"' + proId + '"');
                    keyIdMap.set(proId, []);
                }
                let productItemKeys = keyIdMap.get(proId);
                productItemKeys.push(item.key)
                keyIdMap.set(proId, productItemKeys);

                let productVariants = cartItemProductMap.get(proId);
                if (!productVariants || productVariants == undefined) {
                    cartItemProductMap.set(proId, [])
                    productVariants = [];
                }

                productVariants.push({
                    key: item.key,
                    quantity: item.quantity,
                    id: item.variant_id,
                    price: item.price
                });
                cartItemProductMap.set(proId, productVariants);
                cartItemProductMapByKey.push({
                    key: item.key,
                    price: item.price
                })
            })
        
            let urlData = '/search.js?q=' + handleUrls.join(' OR ') + '&view=bss.bcp';
            const encodeUrlData = encodeURI(urlData);

            let productsSearch = await fetch(
                encodeUrlData, options
            ).then(function(response) {
                if (!response.ok) {
                    throw new Error("HTTP error, status = " + response.status);
                }
                let dataJSON_promise = response.json();
                return dataJSON_promise;
            })
            .catch(function(error) {
                console.log("No! Something error:",error); // eslint-disable-line
            });
            if (productsSearch.length > 0) {
                let productMap = [];
                let checkUnique = [];
                for (let i = 0; i < productsSearch.length; i++) {
                    let pro = productsSearch[i];

                    if (checkUnique.indexOf(pro.id) === -1) {
                        checkUnique.push(pro.id);
                        keyIdMap.get(pro.id).forEach(function(key) {
                            productMap.push({
                                id: pro.id,
                                tags: pro.tags,
                                collections: pro.collections,
                                key: key,
                                title: pro.title
                            });
                        })
                    }
                }

                let invalidQuoteProduct = [];
                productMap.map((item) => {
                    let isValidProduct = BSS_BCP.quote.handleCheckProductQuote(item);
                    if (!isValidProduct) {
                        invalidQuoteProduct.push(item);
                    }
                })

                if (invalidQuoteProduct.length) {
                    let nameList = invalidQuoteProduct.map((item) => {
                        return item.title;
                    })
                    document.querySelector('.invalid-quote-product').innerHTML = nameList.join(', ');
                    let popupHtml = document.querySelector('.popup.popup-validate-product-quote');
                    popupHtml.style.display = 'block';
                    document.querySelector('.popup-close.popup-validate-product-quote').onclick = (event) => {
                        event.preventDefault()
                        popupHtml.style.display = 'none';
                    }
                    document.querySelector('.bss-view-to-quote').onclick = () => {
                        const invalidArray = invalidQuoteProduct.map(item => item.id)
                        productsSearch.forEach((currentProduct) => {
                            cartData.items.forEach(item => {
                                if (!invalidArray.includes(currentProduct.id) && currentProduct.id == item.product_id) {
                                    handleAddToQuote(currentProduct, item, item.quantity);
                                }
                            })
                        })
                        window.location.href = "/apps/customer-portal/r4q/quote-cart"
                    }
                } else {
                    productsSearch.forEach((currentProduct) => {
                        cartData.items.forEach(item => {
                            if (currentProduct.id == item.product_id) {
                                handleAddToQuote(currentProduct, item, item.quantity);
                            }
                        })
                    })
                    window.location.href = "/apps/customer-portal/r4q/quote-cart"
                }
            }

        } else {
            console.log("Could not get cart data") // eslint-disable-line
        }

    }
}

// CONCATENATED MODULE: ./src/js/src/r4q/apply-product-page.js
function applyProductPage(shopData, BSS_BCP, quoteConfig, translations) {
    const productId = shopData.product ? shopData.product.id : null;
    let currentProduct = null;
    let currentVariant = null;
    let urlData = `/search.js?q=` + `id:${productId}` + `&view=bss.bcp`;
    let encodeUrlData = encodeURI(urlData);
    let options = {
        method: 'GET'
    };

    /* --- handle add to quote --- */
    const handleAddToQuote = function (newModal, modalText, currentProduct, currentVariant) {
        let voModule = BSS_BCP.shopModules.find(item => item.module.code === "vo")
        newModal.style.display = "block";
        let currentVariantId = BSS_BCP.helper.handleGetVariantId();
        let currentQuantity = parseInt(BSS_BCP.quote.handleGetQuantity());
        if (currentVariantId && currentProduct && currentProduct.variants && currentProduct.variants.length) {
            currentProduct.variants.map((item) => {
                if (item.id == currentVariantId) {
                    currentVariant = item;
                }
            });
        }
        currentVariantId = currentVariantId ? currentVariantId.toString() : null;
        let quoteCartStorage = window.localStorage.getItem("bssQuoteCart") ? JSON.parse(window.localStorage.getItem("bssQuoteCart")) : [];
        let listVariantStorage = window.localStorage.getItem("bssListVariantQuoteCart") ? JSON.parse(window.localStorage.getItem("bssListVariantQuoteCart")) : [];
        if (!window.localStorage.getItem("bssQuoteCart")) {
            window.localStorage.setItem("bssQuoteCart", '');
        }
        if (!window.localStorage.getItem("bssListVariantQuoteCart")) {
            window.localStorage.setItem("bssListVariantQuoteCart", '');
        }
        if (currentProduct && currentVariant && currentVariantId) {
            let cartItem = {};
            let variantTitles =[]    
            if (quoteCartStorage && quoteCartStorage.length && listVariantStorage && listVariantStorage.length && !voModule.status) {
                if (!listVariantStorage.includes(currentVariantId)) {
                    cartItem = BSS_BCP.quote.renderQuoteCartItem(currentProduct, currentVariant, currentQuantity);
                    listVariantStorage.push(currentVariantId);
                    quoteCartStorage.push(cartItem);
                } else {
                    for (let i = 0; i < quoteCartStorage.length; i++) {
                        let cartItemQty = quoteCartStorage[i].quantity ? parseInt(quoteCartStorage[i].quantity) : 0;
                        if (quoteCartStorage[i].variantId == currentVariantId) {
                            quoteCartStorage[i].quantity = cartItemQty + currentQuantity;
                            break;
                        }
                    }
                }
            } else if (voModule.status) {
                const selectedVariants = currentProduct.variants.filter(item => {
                    const selectedElement = document.getElementById(`${item.id}`)
                    if(selectedElement && +selectedElement.value > 0) {
                        cartItem = BSS_BCP.quote.renderQuoteCartItem(currentProduct, item, +selectedElement.value);
                        quoteCartStorage.push(cartItem);
                        listVariantStorage.push(item.id.toString());
                        return item
                    }
                })
                variantTitles = selectedVariants.map(item => item.title)   
            } else {
                cartItem = BSS_BCP.quote.renderQuoteCartItem(currentProduct, currentVariant, currentQuantity);
                listVariantStorage.push(currentVariantId);
                quoteCartStorage.push(cartItem);
            }
            window.localStorage.setItem("bssQuoteCart", JSON.stringify(quoteCartStorage));
            window.localStorage.setItem("bssListVariantQuoteCart", JSON.stringify(listVariantStorage));
            
            modalText.innerHTML = voModule.status ? `<p>${translations.the_product} <strong>${currentProduct.title} ${variantTitles}</strong> ${translations.added_to_quote}.</p>` 
                :`<p>${translations.the_product} <strong>${currentProduct.title + " " + currentVariant.title}</strong> ${translations.added_to_quote}.</p>`
        }
    };
    /* ------- */

    let getSearchDataReq = fetch(encodeUrlData, options);
    getSearchDataReq
        .then(function (response) {
            if (!response.ok) {
                throw new Error("HTTP error, status = " + response.status);
            }
            let dataJSON_promise = response.json();
            return dataJSON_promise;
        })
        .then(function (responProd) {
            if (responProd.length > 0) {
                currentProduct = responProd[0];
                let checkProduct = BSS_BCP.quote.handleCheckProductQuote(currentProduct);
                if (checkProduct) {
                    let parentProductPage = null;
                    let BSSQuoteAddToCartDefault = BSS_BCP.helper.getAddToCartDefault();
                    let BSSQuoteBuyItNowBtn = BSS_BCP.helper.getBuyItNowBtn();

                    /* Hide buy it now */
                    let delayTime = 100;
                    if (BSS_BCP.storeId === 938) {
                        delayTime = 5;
                    }
                    let handleHideBuyItNowBtn = setInterval(function () {
                        if (BSSQuoteBuyItNowBtn && BSSQuoteBuyItNowBtn.length) {
                            if (quoteConfig && quoteConfig.hide_buy_it_now && BSSQuoteBuyItNowBtn && BSSQuoteBuyItNowBtn.length) {
                                for (let i = 0; i < BSSQuoteBuyItNowBtn.length; i++) {
                                    BSSQuoteBuyItNowBtn[i].classList.add('bss-bcp-quote-hide-buy-it-now');
                                    break;
                                }
                            }
                            clearInterval(handleHideBuyItNowBtn);
                        } else {
                            setTimeout(function () {
                                clearInterval(handleHideBuyItNowBtn);
                            }, 5000);
                        }
                    }, delayTime);
                    /* Hide add to cart*/
                    let handleHideAddToCart = setInterval(function () {
                        let addToCartVOBtn = document.querySelector(".bss-b2b-customer-portal-variants-order-btn")
                        if (BSSQuoteAddToCartDefault && BSSQuoteAddToCartDefault.length) {
                            if (quoteConfig && quoteConfig.hide_cart && BSSQuoteAddToCartDefault && BSSQuoteAddToCartDefault.length) {
                                if(addToCartVOBtn) {
                                    addToCartVOBtn.classList.add("bss-bcp-quote-hide-add-to-cart")        
                                }
                                for (let i = 0; i < BSSQuoteAddToCartDefault.length; i++) {
                                    BSSQuoteAddToCartDefault[i].classList.add('bss-bcp-quote-hide-add-to-cart');
                                    break;
                                }
                            }
                            clearInterval(handleHideAddToCart);
                        } else {
                            setTimeout(function () {
                                clearInterval(handleHideAddToCart);
                            }, 5000);
                        }
                    }, 3000);
                    /* Hide price */

                    let quotePriceListSelector = document.querySelectorAll("[bss-bcp-quote-product-price]");

                    if (quotePriceListSelector && quotePriceListSelector.length) {
                        for (let i = 0; i < quotePriceListSelector.length; i++) {
                            if (BSS_BCP.storeId === 2094 && i == 0) {
                                continue;
                            }
                            if (parseInt(quotePriceListSelector[i].getAttribute('bss-bcp-quote-product-id')) === currentProduct.id){
                                parentProductPage = quotePriceListSelector[i].closest('section')
                                let quotePriceListSelectorProductPage = quotePriceListSelector[i].closest(".section")?quotePriceListSelector[i].closest(".section").querySelectorAll("[bss-bcp-quote-product-price]") : [];
                                if ( quoteConfig && quoteConfig.hide_price){
                                    if (quotePriceListSelectorProductPage.length){
                                        for (let j = 0; j < quotePriceListSelectorProductPage.length; j++) {
                                            quotePriceListSelectorProductPage[j].classList.add('bss-bcp-quote-hide-price');
                                        }
                                    }
                                   let handleHideOriginPriceAndComparePrice = setInterval(()=> {
                                    let comparePriceAndOriginPriceElement
                                    if(BSS_BCP.storeId === 2922) {
                                        comparePriceAndOriginPriceElement = document.querySelectorAll('.bss-b2b-customized-compare-at-price ,.bss-b2b-customized-original-price');
                                    } else {
                                        comparePriceAndOriginPriceElement = parentProductPage.querySelectorAll('.bss-b2b-customized-compare-at-price ,.bss-b2b-customized-original-price');
                                    }
                                        if (comparePriceAndOriginPriceElement.length) {
                                            for (let k = 0; k < comparePriceAndOriginPriceElement.length; k++) {
                                                comparePriceAndOriginPriceElement[k].remove();
                                            }
                                            clearInterval(handleHideOriginPriceAndComparePrice)
                                        }
                                    },500);
                                    setTimeout(()=>{
                                        clearInterval(handleHideOriginPriceAndComparePrice)
                                    },3000)
                                }
                                else if (quoteConfig && !quoteConfig.hide_price) {
                                    let currentElement = document.querySelectorAll('[bss-bcp-quote-product-id="' + currentProduct.id + '"]');
                                    if(currentElement.length) {
                                        currentElement.forEach(i => i.setAttribute("style", "visibility: visible !important"));
                                    }
                                }
                            }
                            break;
                        }
                    }
                    BSS_BCP.helper.handleChangeVariant(quoteConfig,false,parentProductPage);

                    /* Insert Add to quote btn */
                    let BSSAddToQuoteBtn = document.createElement('div');
                    let BSSAddToQuoteBtnText = document.createTextNode(translations.add_to_quote);
                    BSSAddToQuoteBtn.setAttribute('class', 'bss-bcp-add-to-quote-btn');
                    BSSAddToQuoteBtn.appendChild(BSSAddToQuoteBtnText);

                    /* Insert Quote modal */
                    let newModal = document.createElement('div');
                    let modalContent = `<div class="bss-quote-modal-content">
                            <span class="bss-quote-modal-close">&times;</span>
                            <div id="bss-quote-modal-text"></div>
                            <div class="bss-quote-modal-button-group"><div id="bss-quote-continue-shopping">${translations.continue_shopping}</div>
                            <div id="bss-quote-view-quote-cart">${translations.view_quote}</div></div>
                            </div>`;
                    newModal.setAttribute('class', 'bss-quote-modal');
                    newModal.setAttribute('id', 'bss-quote-modal-id');
                    newModal.innerHTML = modalContent;

                    let cartForm = document.querySelectorAll('form[action*="/cart/add"]');
                    let checkQuoteBtn = false
                    if (cartForm && cartForm.length && BSSQuoteAddToCartDefault && BSSQuoteAddToCartDefault.length) {
                        for (let i = 0; i < BSSQuoteAddToCartDefault.length; i++) {
                            let cartForm = BSSQuoteAddToCartDefault[i].closest('form[action*="/cart/add"], div[data-name="product-submit-wrapper"]');
                            if (cartForm && !checkQuoteBtn) {
                                let findQuoteBtn = cartForm.querySelector('.bss-bcp-add-to-quote-btn');
                                let voModule = BSS_BCP.shopModules.find(item => item.module.code === "vo")
                                let elementToInsertModal = '.shopify-section.section';
                                if([3251, 2952].includes(BSS_BCP.storeId)) {
                                    elementToInsertModal = 'body';
                                }
                                if(!findQuoteBtn) {
                                    if(voModule.status && BSS_BCP.page.isProductPage() && i==0) {
                                    let interval = setInterval(() => {
                                        if(document.querySelector('.bss-b2b-customer-portal-variants-order-btn')) {
                                            document.querySelector('.bss-b2b-customer-portal-variants-order-btn').after(BSSAddToQuoteBtn)
                                            document.querySelector(elementToInsertModal).after(newModal);
                                            let viewQuoteButton = document.querySelector('#bss-quote-view-quote-cart');
                                            let modal = document.getElementById("bss-quote-modal-id");
                                            let modalClose = document.getElementsByClassName("bss-quote-modal-close")[0];
                                            let continueButton = document.querySelector('#bss-quote-continue-shopping');
                                            let modalText = document.querySelector("#bss-quote-modal-text");
    
                                            BSSAddToQuoteBtn.onclick = function () {
                                                handleAddToQuote(newModal, modalText, currentProduct, currentVariant);
                                            };
    
                                            if (viewQuoteButton) {
                                                viewQuoteButton.onclick = function () {
                                                    window.location = '/apps/customer-portal/r4q/quote-cart';
                                                }
                                            }
    
                                            if (modalClose) {
                                                modalClose.onclick = function () {
                                                    newModal.style.display = "none";
                                                };
                                            }
                                            if (continueButton) {
                                                continueButton.onclick = function () {
                                                    newModal.style.display = "none";
                                                };
                                            }
    
                                            window.onclick = function (event) {
                                                if (event.target == modal) {
                                                    newModal.style.display = "none";
                                                }
                                            };
                                          clearInterval(interval)
                                        } else {
                                            BSSQuoteAddToCartDefault[i].after(BSSAddToQuoteBtn);
                                            document.querySelector(elementToInsertModal).after(newModal);
                                            let viewQuoteButton = document.querySelector('#bss-quote-view-quote-cart');
                                            let modal = document.getElementById("bss-quote-modal-id");
                                            let modalClose = document.getElementsByClassName("bss-quote-modal-close")[0];
                                            let continueButton = document.querySelector('#bss-quote-continue-shopping');
                                            let modalText = document.querySelector("#bss-quote-modal-text");
    
                                            BSSAddToQuoteBtn.onclick = function () {
                                                handleAddToQuote(newModal, modalText, currentProduct, currentVariant);
                                            };
    
                                            if (viewQuoteButton) {
                                                viewQuoteButton.onclick = function () {
                                                    window.location = '/apps/customer-portal/r4q/quote-cart';
                                                }
                                            }
    
                                            if (modalClose) {
                                                modalClose.onclick = function () {
                                                    newModal.style.display = "none";
                                                };
                                            }
                                            if (continueButton) {
                                                continueButton.onclick = function () {
                                                    newModal.style.display = "none";
                                                };
                                            }
    
                                            window.onclick = function (event) {
                                                if (event.target == modal) {
                                                    newModal.style.display = "none";
                                                }
                                            };
                                          clearInterval(interval)
                                        }
                                    }, 3000) 
                                      break;
                                    } else {
                                        BSSQuoteAddToCartDefault[i].after(BSSAddToQuoteBtn);
                                        checkQuoteBtn = true;
                                        document.querySelector(elementToInsertModal).after(newModal);
                                        let modal = document.getElementById("bss-quote-modal-id");
                                        let modalClose = document.getElementsByClassName("bss-quote-modal-close")[0];
                                        let continueButton = document.querySelector('#bss-quote-continue-shopping');
                                        let viewQuoteButton = document.querySelector('#bss-quote-view-quote-cart');
                                        let modalText = document.querySelector("#bss-quote-modal-text");
                                        if (modalClose) {
                                            modalClose.onclick = function () {
                                                newModal.style.display = "none";
                                            };
                                        }
                                        if (continueButton) {
                                            continueButton.onclick = function () {
                                                newModal.style.display = "none";
                                            };
                                        }
                                        if (viewQuoteButton) {
                                            viewQuoteButton.onclick = function () {
                                                window.location = '/apps/customer-portal/r4q/quote-cart';
                                            }
                                        }
                                        window.onclick = function (event) {
                                            if (event.target == modal) {
                                                newModal.style.display = "none";
                                            }
                                        };
                                        /* handle Add to quote */
                                        BSSAddToQuoteBtn.onclick = function () {
                                            handleAddToQuote(newModal, modalText, currentProduct, currentVariant);
                                        };
                                    }
                                }
                            }
                            if (quoteConfig && quoteConfig.hide_cart) {
                                let elementToInsertModal = '.shopify-section.section';
                                BSSQuoteAddToCartDefault[i].classList.add('bss-bcp-quote-hide-add-to-cart');
                                BSSQuoteAddToCartDefault[i].after(BSSAddToQuoteBtn);
                                        checkQuoteBtn = true;
                                        document.querySelector(elementToInsertModal).after(newModal);
                                        let modal = document.getElementById("bss-quote-modal-id");
                                        let modalClose = document.getElementsByClassName("bss-quote-modal-close")[0];
                                        let continueButton = document.querySelector('#bss-quote-continue-shopping');
                                        let viewQuoteButton = document.querySelector('#bss-quote-view-quote-cart');
                                        let modalText = document.querySelector("#bss-quote-modal-text");
                                        if (modalClose) {
                                            modalClose.onclick = function () {
                                                newModal.style.display = "none";
                                            };
                                        }
                                        if (continueButton) {
                                            continueButton.onclick = function () {
                                                newModal.style.display = "none";
                                            };
                                        }
                                        if (viewQuoteButton) {
                                            viewQuoteButton.onclick = function () {
                                                window.location = '/apps/customer-portal/r4q/quote-cart';
                                            }
                                        }
                                        window.onclick = function (event) {
                                            if (event.target == modal) {
                                                newModal.style.display = "none";
                                            }
                                        };
                                        /* handle Add to quote */
                                        BSSAddToQuoteBtn.onclick = function () {
                                            handleAddToQuote(newModal, modalText, currentProduct, currentVariant);
                                        };
                                break;
                            }
                        }
                    }
                } else {
                    let currentElement = document.querySelectorAll('[bss-bcp-quote-product-id="' + currentProduct.id + '"]');
                    if (currentElement.length) {
                        currentElement.forEach(i => i.setAttribute("style", "visibility: visible !important"));
                    }
                }

            } else {
            // eslint-disable-next-line no-console
                console.log("No data");
            }
        })
        .catch(function (error) {
            // eslint-disable-next-line no-console
            console.log("No! Something error:",error);
        });
}

// CONCATENATED MODULE: ./src/js/src/r4q/apply-collection-page.js
function applyCollectionPage(shopData, BSS_BCP, quoteConfig, translations, customSelector = []) {
    let proId = null;
    let handleUrls = [];
    let productList = [];
    let productMap = new Map();
    let currentQuantity = 1;
    let styles = `
        .card__heading a:after{
          bottom:200px !important;
         }
         .isolate{
         z-index: initial;  
         }
         .bss-quote-modal-content{
             color: black !important;
         }
            `;
    let styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
    let quotePriceListSelector = [];

    /* --- handle add to quote --- */
    const handleAddToQuote = function (newModal, modalText, currentProduct, currentVariant, currentVariantId, currentQuantity) {
        newModal.style.display = "block";
        currentVariantId = currentVariantId ? currentVariantId.toString() : null;
        let quoteCartStorage = window.localStorage.getItem("bssQuoteCart") ? JSON.parse(window.localStorage.getItem("bssQuoteCart")) : [];
        let listVariantStorage = window.localStorage.getItem("bssListVariantQuoteCart") ? JSON.parse(window.localStorage.getItem("bssListVariantQuoteCart")) : [];
        if (!window.localStorage.getItem("bssQuoteCart")) {
            window.localStorage.setItem("bssQuoteCart", '');
        }
        if (!window.localStorage.getItem("bssListVariantQuoteCart")) {
            window.localStorage.setItem("bssListVariantQuoteCart", '');
        }
        if (currentProduct && currentVariant && currentVariantId) {
            let cartItem = {};
            if (quoteCartStorage && quoteCartStorage.length && listVariantStorage && listVariantStorage.length) {
                if (!listVariantStorage.includes(currentVariantId)) {
                    listVariantStorage.push(currentVariantId);
                    cartItem = BSS_BCP.quote.renderQuoteCartItem(currentProduct, currentVariant, currentQuantity);
                    quoteCartStorage.push(cartItem);
                } else {
                    for (let i = 0; i < quoteCartStorage.length; i++) {
                        let cartItemQty = quoteCartStorage[i].quantity ? quoteCartStorage[i].quantity : 0;
                        if (quoteCartStorage[i].variantId == currentVariantId) {
                            quoteCartStorage[i].quantity = cartItemQty + 1;
                            break;
                        }
                    }
                }
            } else {
                cartItem = BSS_BCP.quote.renderQuoteCartItem(currentProduct, currentVariant, currentQuantity);
                listVariantStorage.push(currentVariantId);
                quoteCartStorage.push(cartItem);
            }
            window.localStorage.setItem("bssQuoteCart", JSON.stringify(quoteCartStorage));
            window.localStorage.setItem("bssListVariantQuoteCart", JSON.stringify(listVariantStorage));
            if (modalText && modalText.length) {
                modalText.forEach(modalTextChild => {
                    modalTextChild.innerHTML = `<p>${translations.the_product} <strong>${currentProduct.title + " " + currentVariant.title}</strong> ${translations.added_to_quote}.</p>`;
                })
            }
        }
    };
    /* -------*/
    if (customSelector && customSelector.length) {
        quotePriceListSelector = customSelector;
    } else {
        quotePriceListSelector = document.querySelectorAll("[bss-bcp-quote-product-price]");
    }

    if (quotePriceListSelector && quotePriceListSelector.length) {
        let isQuoteHidePrice = !!BSS_BCP.quoteConfig.hide_price;
        for (let i = 0; i < quotePriceListSelector.length; i++) {
            proId = quotePriceListSelector[i].getAttribute('bss-bcp-quote-product-id');
            if (proId) {
                handleUrls.push('id:"' + proId + '"');
            }
        }
        let urlData = '/search.js?q=' + handleUrls.join(' OR ') + '&view=bss.bcp';
        let encodeUrlData = encodeURI(urlData);
        let options = {
            method: 'GET'
        };
        let getSearchDataReq = fetch(encodeUrlData, options);
        getSearchDataReq
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("HTTP error, status = " + response.status);
                }
                let dataJSON_promise = response.json();
                return dataJSON_promise;
            })
            .then(function (responProd) {
                if (responProd.length > 0) {

                    for (let i = 0; i < responProd.length; i++) {
                        let checkProduct = BSS_BCP.quote.handleCheckProductQuote(responProd[i]);
                        if (checkProduct) {
                            let responProId = responProd[i].id + "";
                            productList.push(responProId);
                            productMap.set(responProId, responProd[i]);
                        }
                        if((checkProduct && !isQuoteHidePrice) || !checkProduct) {
                            let currentElement = document.querySelectorAll('[bss-bcp-quote-product-id="' + responProd[i].id + '"]');
                            if(currentElement.length) {
                                currentElement.forEach(i => i.setAttribute("style", "visibility: visible !important"));
                            }
                        }
                    }
                    let checkExistR4Q = new Map();
                    for (let i = 0; i < quotePriceListSelector.length; i++) {
                        proId = quotePriceListSelector[i].getAttribute('bss-bcp-quote-product-id') + "";
                        if (proId && productList.includes(proId)) {
                            let currentProduct = productMap.get(proId);
                            let currentVariant = currentProduct.variants[0];
                            let currentVariantId = currentVariant.id;
                            /* Hide price */
                            if (quoteConfig && quoteConfig.hide_price) {
                                quotePriceListSelector[i].classList.add('bss-bcp-quote-hide-price');
                                if (typeof (BSS_B2B) !== "undefined") {
                                    let priceCardElement = quotePriceListSelector[i].closest('.card-information');
                                    if (priceCardElement) {
                                        let handleHideOriginPriceAndComparePrice = setInterval(() => {
                                            let comparePriceAndOriginPriceElement = priceCardElement.querySelectorAll('.bss-b2b-customized-compare-at-price ,.bss-b2b-customized-original-price');
                                            if (comparePriceAndOriginPriceElement.length) {
                                                for (let k = 0; k < comparePriceAndOriginPriceElement.length; k++) {
                                                    comparePriceAndOriginPriceElement[k].remove();
                                                }
                                                clearInterval(handleHideOriginPriceAndComparePrice)
                                            }
                                        }, 100);
                                        setTimeout(() => {
                                            clearInterval(handleHideOriginPriceAndComparePrice)
                                        }, 1000)
                                    }
                                }
                            }
                            /* Insert Add to quote btn */
                            let BSSAddToQuoteBtn = document.createElement('div');
                            let BSSAddToQuoteBtnText = document.createTextNode(translations.add_to_quote);
                            let sectionIdParent = "";
                            let isFeatureProduct = false;
                            let featureProductParent = null;
                            if (quotePriceListSelector[i].closest('section')) {
                                if (quotePriceListSelector[i].closest('section').querySelector('.featured-product')) {
                                    isFeatureProduct = true;
                                    featureProductParent = quotePriceListSelector[i].closest('section')
                                }
                                sectionIdParent = quotePriceListSelector[i].closest('section,.product__info-container').getAttribute('id') ? quotePriceListSelector[i].closest('section,.product__info-container').getAttribute('id') : "";
                            }

                            if (typeof checkExistR4Q.get(proId) === "undefined") {
                                checkExistR4Q.set(proId, [])
                            }
                            if (checkExistR4Q.get(proId).indexOf(sectionIdParent) === -1) {
                                let sectionIdParentArr = checkExistR4Q.get(proId);
                                sectionIdParentArr.push(sectionIdParent);
                                checkExistR4Q.set(proId, sectionIdParentArr)
                                BSSAddToQuoteBtn.setAttribute('class', 'bss-bcp-add-to-quote-btn');
                                BSSAddToQuoteBtn.appendChild(BSSAddToQuoteBtnText);
                                if (isFeatureProduct) {
                                    /* Insert Add to quote btn feature product */
                                    let buttonFeatureProduct = quotePriceListSelector[i].closest('section').querySelector('form[action*="/cart/add"] button');
                                    let findQuoteBtn = quotePriceListSelector[i].closest('section').querySelector('.bss-bcp-add-to-quote-btn');
                                    if (buttonFeatureProduct && !findQuoteBtn) {
                                        buttonFeatureProduct.after(BSSAddToQuoteBtn)
                                    }
                                    BSS_BCP.helper.handleChangeVariant(quoteConfig, isFeatureProduct, featureProductParent);
                                } else {
                                    /* Insert Add to quote btn feature collection */
                                    let parentR4Q = quotePriceListSelector[i].closest('.card-information');
                                    if (parentR4Q) {
                                        parentR4Q.after(BSSAddToQuoteBtn)
                                    } else {
                                        quotePriceListSelector[i].after(BSSAddToQuoteBtn);
                                    }
                                }
                            }
                            /* Hide Add to cart */
                            if (quoteConfig && quoteConfig.hide_cart) {
                                let productItem = null;
                                if (BSS_BCP.storeId === 885) {
                                    productItem = quotePriceListSelector[i].closest('.productitem');
                                    let addToCartBtn = productItem ? productItem.querySelector('.atc--button') : null;
                                    if (addToCartBtn) {
                                        addToCartBtn.remove();
                                    }
                                }
                                if (BSS_BCP.storeId === 1045) {
                                    productItem = quotePriceListSelector[i].closest('.product.animate');
                                    let addToCartBtn = productItem ? productItem.querySelector('.product-details .purchase') : null;
                                    if (addToCartBtn) {
                                        addToCartBtn.remove();
                                    }
                                }
                                if (isFeatureProduct|| BSS_BCP.storeId === 1703) {
                                    productItem = quotePriceListSelector[i].closest('section').querySelectorAll('form[action*="/cart/add"]');
                                } else {
                                    if(BSS_BCP.storeId === 2922) {
                                        productItem = document.querySelectorAll('form[action*="/cart/add"],.card__content');
                                    } else {
                                        productItem = quotePriceListSelector[i].closest('li').querySelectorAll('form[action*="/cart/add"],.card__content');
                                    }
                                }
                                if (productItem.length) {
                                    for (let i = 0; i < productItem.length; i++) {
                                        let addToCartBtn = productItem[i].querySelector(BSS_BCP.helper.AddToCartDefaultElement);
                                        if (addToCartBtn) {
                                            addToCartBtn.classList.add('bss-bcp-quote-hide-add-to-cart');
                                        }
                                    }
                                }
                            }
                            /* Hide buy it now */
                            if (quoteConfig && quoteConfig.hide_buy_it_now) {
                                if (isFeatureProduct) {
                                    let productItem = quotePriceListSelector[i].closest('section').querySelectorAll('form[action*="/cart/add"]');
                                    if (productItem.length) {
                                        for (let i = 0; i < productItem.length; i++) {
                                            let buyItNowtBtn = productItem[i].querySelector(BSS_BCP.helper.buyItNowtElements);
                                            if (buyItNowtBtn) {
                                                buyItNowtBtn.classList.add('bss-bcp-quote-hide-buy-it-now');
                                            }
                                        }
                                    }
                                }
                            }

                            /* Insert Quote modal */
                            let newModal = document.createElement('div');
                            let modalContent = `<div class="bss-quote-modal-content">
                                    <span id="bss-quote-modal-close-id-${currentVariantId}" class="bss-quote-modal-close">&times;</span>
                                    <div id="bss-quote-modal-text-${currentVariantId}" class="bss-quote-modal-text"></div>
                                    <div class="bss-quote-modal-button-group"><div id="bss-quote-continue-shopping-${currentVariantId}" class="bss-quote-continue-shopping">${translations.continue_shopping}</div>
                                    <div id="bss-quote-view-quote-cart-${currentVariantId}" class="bss-quote-view-quote-cart">${translations.view_quote}</div></div>
                                </div>`;
                            newModal.setAttribute('class', 'bss-quote-modal');
                            newModal.setAttribute('id', `bss-quote-modal-id-${currentVariantId}`);
                            newModal.innerHTML = modalContent;
                            BSSAddToQuoteBtn.after(newModal);

                            let modal = document.getElementById(`bss-quote-modal-id-${currentVariantId}`);
                            let modalClose = document.querySelectorAll(`#bss-quote-modal-close-id-${currentVariantId}`);
                            let continueButton = document.querySelectorAll(`#bss-quote-continue-shopping-${currentVariantId}`);
                            let viewQuoteButton = document.querySelectorAll(`#bss-quote-view-quote-cart-${currentVariantId}`);
                            let modalSelector = document.querySelectorAll(`#bss-quote-modal-id-${currentVariantId}`);
                            if (modalClose.length) {
                                modalClose.forEach(modalCloseChild => {
                                    modalCloseChild.onclick = function () {
                                        if (modalSelector.length) {
                                            modalSelector.forEach(modalSelectorChild => {
                                                modalSelectorChild.style.display = "none";
                                            })
                                        }
                                    }
                                })
                            }
                            if (continueButton.length) {
                                continueButton.forEach(continueButtonChild => {
                                    continueButtonChild.onclick = function () {
                                        if (modalSelector.length) {
                                            modalSelector.forEach(modalSelectorChild => {
                                                modalSelectorChild.style.display = "none";
                                            })
                                        }
                                    }
                                })
                            }
                            if (viewQuoteButton.length) {
                                viewQuoteButton.forEach(viewQuoteButtonChild => {
                                    viewQuoteButtonChild.onclick = function () {
                                        window.location = '/apps/customer-portal/r4q/quote-cart';
                                    }
                                })
                            }
                            window.onclick = function (event) {
                                if (event.target == modal) {
                                    newModal.style.display = "none";
                                }
                            };

                            let modalText = document.querySelectorAll(`#bss-quote-modal-text-${currentVariantId}`);
                            /* handle Add to quote */
                            BSSAddToQuoteBtn.onclick = function () {
                                handleAddToQuote(newModal, modalText, currentProduct, currentVariant, currentVariantId, currentQuantity);
                            };
                        }
                    }
                }
            })
            .catch(function (error) {
                // eslint-disable-next-line no-console
                console.log("No! Something error:", error);
            });
    }
}
// CONCATENATED MODULE: ./src/js/src/r4q/index.js




function initQuote(shopData, BSS_BCP) {
    const productId = shopData.product ? shopData.product.id : null;
    const customerId = shopData.customer ? shopData.customer.id : null;
    const customerTags = shopData.customer ? shopData.customer.tags : null;
    const quoteCustomerIds = BSS_BCP.quoteRule ? BSS_BCP.quoteRule.customer_ids : null;
    const quoteProductIds = BSS_BCP.quoteRule ? BSS_BCP.quoteRule.product_ids : null;
    const quoteCustomerTags = BSS_BCP.quoteRule ? BSS_BCP.quoteRule.customer_tags : null;
    const quoteProductTags = BSS_BCP.quoteRule ? BSS_BCP.quoteRule.product_tags : null;
    const quoteProductCollections = BSS_BCP.quoteRule ? BSS_BCP.quoteRule.product_collections : null;
    const quoteProductConditionType = BSS_BCP.quoteRule ? BSS_BCP.quoteRule.product_condition_type : 0;
    const quoteApplyTo = BSS_BCP.quoteRule ? BSS_BCP.quoteRule.apply_to : 3;
    const quoteConfig = BSS_BCP.quoteConfig ? BSS_BCP.quoteConfig : {};
    const translations = {};
    BSS_BCP.quoteTranslations && BSS_BCP.quoteTranslations.map(item => {
        translations[item.key] = item.value;
    });

    let isProductPage = BSS_BCP.page.isProductPage();
    let isCollectionPage = BSS_BCP.page.isCollectionPage();
    let isHomePage = BSS_BCP.page.isHomePage();
    let isSearchPage = BSS_BCP.page.isSearchPage();
    let isCartPage = BSS_BCP.page.isCartPage();

    let quoteCustomerIdsArr = quoteCustomerIds ? quoteCustomerIds.split(",") : [];
    let quoteProductIdsArr = quoteProductIds ? quoteProductIds.split(",") : [];
    let quoteCustomerTagsArr = quoteCustomerTags ? quoteCustomerTags.split(",") : [];
    let quoteProductTagsArr = quoteProductTags ? quoteProductTags.split(",") : [];
    let quoteProductCollectionsArr = quoteProductCollections ? quoteProductCollections.split(",") : [];

    /* --- Get quantity --- */
    BSS_BCP.quote.handleGetQuantity = function () {
        let quantity = 1;
        let BSSQuoteQuantityInput = document.querySelectorAll(
            'input[type="number"][name="quantity"],' +
            'input[type="number"][data-quantity-input],' +
            'input[type="number"][class$="quantity"],' +
            'input[id^="Quantity"],' +
            'input[name="quantity"]'
        );
        if (BSSQuoteQuantityInput && BSSQuoteQuantityInput.length) {
            quantity = BSSQuoteQuantityInput[BSSQuoteQuantityInput.length - 1].value;
        }
        return quantity;
    };

    /* --- Check customer --- */
    BSS_BCP.quote.handleCheckCustomer = function () {
        let checkCustomer = false;
        if (quoteApplyTo == 0) {
            if (customerId == null) {
                checkCustomer = false;
            } else {
                if (quoteCustomerIdsArr.indexOf(customerId + "") !== -1) {
                    checkCustomer = true;
                }
            }
        } else if (quoteApplyTo == 1) {
            if (customerTags == null) {
                checkCustomer = false;
            } else {
                let checkArray = customerTags.filter(tag => quoteCustomerTagsArr.includes(tag + ""));
                if (checkArray.length != 0) {
                    checkCustomer = true;
                }
            }
        } else if (quoteApplyTo == 2) {
            if (customerId != null) {
                checkCustomer = true;
            }
        } else if (quoteApplyTo == 3) {
            checkCustomer = true;
        }
        return checkCustomer;
    };
    const showPriceWhenNotApplied = () => {
        let priceElements = document.querySelectorAll("[bss-bcp-quote-product-price]");
        if(priceElements.length) {
            priceElements.forEach(i => i.setAttribute("style", "visibility: visible !important"));
        }
    }
    /* --- Check product --- */
    BSS_BCP.quote.handleCheckProductQuote = function (productData) {
        let checkProduct = false;
        let proId = productData.id;
        let listCollectionId = productData.collections;
        let proTags = productData.tags;

        if (quoteProductConditionType == 0) {
            checkProduct = true;
        } else if (quoteProductConditionType == 1) {
            if (quoteProductIdsArr.length && proId != null && quoteProductIdsArr.indexOf(proId + "") !== -1) {
                checkProduct = true;
            }
        } else if (quoteProductConditionType == 2) {
            if (quoteProductCollections.length && listCollectionId.length) {
                let checkArray = listCollectionId.filter((collection) => quoteProductCollectionsArr.includes(collection + ""));
                if (checkArray.length > 0) {
                    checkProduct = true;
                }
            }
        } else if (quoteProductConditionType == 3) {
            if (proTags && proTags.length) {
                let checkArray = proTags.filter((tag) => quoteProductTagsArr.includes(tag + ""));
                if (checkArray.length > 0) {
                    checkProduct = true;
                }
            }
        }
        return checkProduct;
    };

    /* --- Cart item --- */
    BSS_BCP.quote.renderQuoteCartItem = function (currentProduct, currentVariant, currentQuantity) {
        let featureImage = null;
        if (currentVariant && currentVariant.image) {
            featureImage = currentVariant.image;
        } else if (currentProduct && currentProduct.featureImage) {
            featureImage = currentProduct.featureImage;
        }
        return {
            "productId": currentProduct.id,
            "productTitle": currentProduct.title,
            "variantId": currentVariant.id,
            "variantTitle": currentVariant.title,
            "featureImage": featureImage,
            "price": currentVariant.price,
            "quantity": currentQuantity,
            "productTags": currentProduct.tags,
            "productCollections": currentProduct.collections,
        };
    };

    /* --- Insert icon cart --- */
    let customerCondition = BSS_BCP.quote.handleCheckCustomer();
    if (customerCondition) {
        let body = document.querySelector('body');
        let bssQuoteCartIcon = document.createElement('div');
        bssQuoteCartIcon.setAttribute('class', 'bss-quote-cart-icon');
        bssQuoteCartIcon.innerHTML = `&#128722;`;
        if (body) {
            body.append(bssQuoteCartIcon);
            bssQuoteCartIcon.onclick = function () {
                window.location = "/apps/customer-portal/r4q/quote-cart";
            }
        }
    }

    /* --- Apply to product page --- */
    let quoteConditionsForProductPage = isProductPage && customerCondition && productId != null;
    if (quoteConditionsForProductPage) {
        if(BSS_BCP.storeId === 1703){
            setTimeout(()=>{
                applyCollectionPage(shopData, BSS_BCP, quoteConfig, translations);   
            },2000)
        }
        else applyProductPage(shopData, BSS_BCP, quoteConfig, translations); 
    }

    let quoteConditionsForCartPage = (isCartPage || isProductPage) && customerCondition;
    if ([2083].includes(BSS_BCP.storeId)) {
        quoteConditionsForCartPage =  customerCondition;
    }
    if (quoteConditionsForCartPage) {
        setTimeout(() => {
            applyCartPage(shopData, BSS_BCP, quoteConfig, translations);
        }, 1000)
        if ([2083].includes(BSS_BCP.storeId)) {
            const miniCart = document.querySelector("#site-cart-sidebar , .cart-section")
            if (miniCart) {
                const cartItems = miniCart.querySelector("#AjaxCartForm")
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.type === "childList") {
                            const r4qBtn = miniCart.querySelector(".bss-b2b-customer-portal-btn-quote-default")
                            if (!r4qBtn) {
                                setTimeout(() => {
                                    applyCartPage(shopData, BSS_BCP, quoteConfig, translations);
                                }, 500)
                            }
                        }
                    })
                })
                observer.observe(cartItems, {childList: true})
            }
        }
        if ([2094, 1532, 2688].includes(BSS_BCP.storeId)) {
            let addToCartBtn = BSS_BCP.helper.getAddToCartDefault()
            if (addToCartBtn.length) {
                addToCartBtn.forEach((e) => {
                    e.addEventListener('click', () => {
                        setTimeout(() => {
                            applyCartPage(shopData, BSS_BCP, quoteConfig, translations);
                        }, 1000)
                    })
                })
            }
        }
    }
    /* --- Apply to Collection page, Home page, Search page --- */
    let quoteConditionForCollection = (isCollectionPage || isSearchPage || isHomePage) && customerCondition;
    if (quoteConditionForCollection) {
		if([1858].includes(BSS_BCP.storeId)) {
			setTimeout(function() {
				applyCollectionPage(shopData, BSS_BCP, quoteConfig, translations);
			}, 1500);
		} else {
			applyCollectionPage(shopData, BSS_BCP, quoteConfig, translations);
		}
    }

    if(!customerCondition) {
        showPriceWhenNotApplied();
    }
    /* --- Apply to feature product and recommended product ---*/
    let quoteConditionForFeaturedCollection = isProductPage;
    if (quoteConditionForFeaturedCollection) {
        let featuredProductSelector = BSS_BCP.helper.featuredCollectionSelector();
        if (featuredProductSelector && featuredProductSelector.length && customerCondition) {
            applyCollectionPage(shopData, BSS_BCP, quoteConfig, translations, featuredProductSelector);
        }
        const windowHeight = window.innerHeight;
        const firstSectionHeight = windowHeight;
        const secondSectionHeight = windowHeight;
        const scrollHandlerInProductPage = () => {
            const handleRecommendedProduct = () => {
                let recommendedProductSelector = BSS_BCP.helper.recommendedProductSelector();
                if (recommendedProductSelector && recommendedProductSelector.length) {
                    if(customerCondition) {
                        applyCollectionPage(shopData, BSS_BCP, quoteConfig, translations, recommendedProductSelector);
                    } else {
                        showPriceWhenNotApplied();
                    }                  
                    window.removeEventListener('scroll', scrollHandlerInProductPage);
                }
            }
            let scrollPosition = window.scrollY;
            if (scrollPosition >= 0 && scrollPosition < firstSectionHeight) {
                handleRecommendedProduct();
            } else if (scrollPosition >= firstSectionHeight && scrollPosition < firstSectionHeight + secondSectionHeight) {
                handleRecommendedProduct();
            } else if (scrollPosition >= firstSectionHeight + secondSectionHeight && scrollPosition < document.body.clientHeight) {
                handleRecommendedProduct();
            } else {
                handleRecommendedProduct();
            }
        }

        window.addEventListener('scroll', scrollHandlerInProductPage);

    }
}
// CONCATENATED MODULE: ./src/js/src/helper/index.js
function helper(BSS_BCP) {
    BSS_BCP.helper.getQueryArray = function () {
        let vars = [], hash;
        let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (let i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    };

    BSS_BCP.helper.handleGetVariantId = function () {
        let variantId = null;
        let variantSelector = null;
        let queryArray = BSS_BCP.helper.getQueryArray();
        let cartForm = document.querySelectorAll('form[action*="/cart/add"]');
        if (cartForm && cartForm.length) {
            for (let i = 0; i < cartForm.length; i++) {
                variantSelector = cartForm[i].querySelectorAll('select[name="id"],' + 'input[name="id"]');
                if (variantSelector.length) {
                    break;
                }
            }
        }
        if (variantSelector && variantSelector.length) {
            variantId = variantSelector[0].value;
        }
        if (queryArray.indexOf("variant") !== -1) {
            variantId = queryArray["variant"];
        }
        return variantId;

    };

    BSS_BCP.helper.handleChangeVariant = function (quoteConfig, isFeatureProduct, productParent) {
        let variantSelector = null;
        let cartForm = "";
        if (isFeatureProduct) {
            cartForm = productParent ? productParent.querySelectorAll('.featured-product') : null;
        } else {
            cartForm = productParent ? productParent.querySelectorAll('form[action*="/cart/add"]'): null;
        }
        if (cartForm && cartForm.length) {
            for (let i = 0; i < cartForm.length; i++) {
                variantSelector = cartForm[i].querySelectorAll('select[name="id"],' + 'input[name="id"]');
                if (variantSelector.length) {
                    break;
                }
            }
        }
        if (variantSelector && variantSelector.length) {
            for (let i = 0; i < variantSelector.length; i++) {
                let element = variantSelector[i];
                element.addEventListener("change", function () {
                    let getVariant = setInterval(function () {
                        let quotePriceListSelector = productParent ? productParent.querySelectorAll("[bss-bcp-quote-product-price]") : null;
                        if (quotePriceListSelector && quotePriceListSelector.length && quoteConfig && quoteConfig.hide_price) {
                            for (let i = 0; i < quotePriceListSelector.length; i++) {
                                quotePriceListSelector[i].remove();
                            }
                        }
                    }, 200);
                    setTimeout(function () {
                        clearInterval(getVariant);
                    }, 3000);
                });
            }
        }
    };

    BSS_BCP.helper.getProductNameList = (invalidNtProduct) => {
        let nameList = invalidNtProduct.map((item) => {
            return item.title;
        });
        return nameList.join(', ');
    }

    BSS_BCP.helper.updateCart = async function (itemUpdate) {
        let _cart = null;
        try {
            const cartUpdate = await fetch('/cart/update.js', {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    updates: itemUpdate
                })
            });
            _cart = await cartUpdate.json();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log('No! Error update cart NT', e);
        }
        return _cart;
    }

    BSS_BCP.helper.getCart = async function () {
        let _cart = null;
        try {
            const getCartDataReq = await fetch("/cart.js", {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            _cart = await getCartDataReq.json();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log('No! Error get cart NT', e);
        }
        return _cart;
    }

    BSS_BCP.helper.checkoutBtnMiniCart = 'form[action*="/cart"] [name="checkout"],' +
        '#dropdown-cart button.btn.btn-checkout.show,' +
        'a.btn.disabled.ttmodalbtn[href="/checkout"],' +
        '.baskettop button.mini-cart-checkout,' +
        '.tt-dropdown-menu .btn.itemCheckout,' +
        '.bss-btn-checkout-mini-cart,' +
        `#slidedown-cart button[onclick="window.location='/checkout'"],` +
        '#dropdown-cart button.btn.btn-checkout,' +
        'form[action="/cart/add"] .product-form--atc .shopify-payment-button button.shopify-payment-button__button,' +
        'form[action*="/cart"] a[href="/cart"],' +
        '#header-mini-cart-footer > div > div.mini-cart-footer-actions > a,' +
        '#CartDrawer-Checkout,' +
        '.\\#cart-sidebar-checkout .\\#button,' +
        'form[action="/cart"] .\\#button,' +
        '.button.add_to_cart.checkout';
    
    BSS_BCP.helper.ajaxCartElement = '[id^="AddToCart"]:not(form), [id^="addToCart"]:not(form):not(span), button[aria-controls="CartDrawer"], a[aria-controls="CartDrawer"], button[name="add"].product-form__add-to-cart,' +
    'button[name="add"].product__add-to-cart-button, button[name="add"].add-to-cart, a.ajax-cart__toggle, span.icon__fallback-text, button#add-to-cart.add-to-cart, a.cart-toggle,' +
    '.mini-cart-wrap[data-cart-mini-toggle], .addtocart-button-active[data-product-submit], button.product-form--atc-button, button.productitem--action-atc, #add-to-cart-product-template,' +
    '.product-form__add-button[data-action="add-to-cart"], .header__cart-toggle[data-action="toggle-mini-cart"], button[type="submit"][data-action="add-to-cart"], button.btn-addtocart,' +
    'form[action*="/cart/add"] input.AddtoCart, a[data-cart-toggle][data-dropdown-menu], input[data-btn-addtocart], .cart-block-click, button[data-btn-addtocart], a.js-cart-trigger[href="/cart"],' +
    'form.js-product-form, form[action*="/cart/add"] button.single_add_to_cart_button.button, .Header__Wrapper .Header__FlexItem a[data-drawer-id="sidebar-cart"], button.product-form__cart-submit,' +
    '.add-to-cart-box .add-to-cart, a.header-cart-btn.cart-toggle, .product-page--submit-action .btn, .ajax-submit.action_button.add_to_cart, .site-header__cart.cart-modal, form[action*="/cart/add"] button.ajax-submit.button--add-to-cart,' +
    'form[action*="/cart/add"] div.add-to-cart button.button[type="submit"], a.add-cart-btn, button.tt-dropdown-toggle, .quick-view button.add-to-cart-btn.btn, button.add.font--secondary-button, button[type="submit"].gf_add-to-cart.product-form-product-template,' +
    'a.header--cart-link.font--accent, .cart-container, .icon-bag.mini_cart.dropdown_link, a.my-cart-link, .product-form--button-container button.product-form--add-to-cart, .product-form--submit span.price, a.push_side.pr.cb.chp.db,' +
    '.ProductForm__AddToCart, .slideout__trigger-mobile-menu.js-mini-cart-trigger.js-slideout-open, button.btn.btn--full.btn--status.btn--animated.js-product-button-add-to-cart, a.header__btn-cart.js-popup-button, .payment-buttons button[data-add-to-cart],' +
    'a.js-product-button-add-to-cart, .js-drawer-open-cart, button.btn.btn--tertiary.add-to-cart, .cart-link, .mini-cart a.icon-link, .quick-cart__indicator, .add-to-cart-box, .header-wrapper .mini-cart, .woodmart-add-btn,' +
    '.ajax-cart.ajax-cart--drawer, #custom_atc_button, .header-middle .mini-cart, #mini-cart-toggle a.head-slot-nav-link.head-slot-cart-link, .quick-add__submit, .header__icon--cart, .product-form__buttons.w3_bg .button--secondary.button--full-width,' +
    '.product-form__buttons button[name="add"], .button--add-to-cart, .product-form__add-button.button--primary, .purchase-details__buttons button[name="add"],' +
    '.header-cart-details, .btn-get-your-now.js-product-atc'; 

    BSS_BCP.helper.mouseOverAjaxCart = '.icon-cart-header, .woodmart-cart-wrapper, .icon.header__icon, .top-cart-holder.hover-dropdown, .header__action-list .header__action-item--cart';

    BSS_BCP.helper.checkoutBtnCartPage = 'a.button.checkout-button[href="/checkout"],' +
        'form[action*="/checkout"] .add_to_cart,' +
        'form[action*="/cart"]#cart_form #checkout,' +
        'form[action*="/cart"] button.Cart__Checkout,' +
        'form[action*="/cart"] button.cart__checkout,' +
        'form[action*="/cart"] [name="checkout"][type="submit"],' +
        'form[action*="/cart"] button[type="submit"].c-btn.c-btn--light.cart__button-update.update-cart,' +
        'form[action*="/cart"] .sp-proceed-to-checkout a[href="/checkout/"],' +
        'form[action*="/cart"] div.cart__checkout:not(.bss-fix-nt),' +
        'button.Cart__Checkout.Button.Button--primary.Button--full,' +
        'button[name="checkout"].btn,' +
        'form[action*="/checkout"] [name="checkout"],' +
        '.cart__footer .cart__checkout-button.button,' +
        '#cartform #checkout,' +
        '.button.checkout,' +
        '.bss-b2b-customer-portal-nt-checkout-btn,' +
        '.checkout-button.button.button--primary.button--full,' +
        '.button.cursor-pointer[name="checkout"],' +
        '#CartDrawer-Checkout,' +
        '#cart-checkout,' +
        '#checkout,' +
        '#CheckOut,' +
        'div.push-btn.inline-block,' +
        '[name="checkout"]';

    BSS_BCP.helper.CheckoutBtnDefaultQuery = 'form[action*="/cart"] [name="checkout"],' +
        '#dropdown-cart button.btn.btn-checkout.show,' +
        'a.button.checkout-button[href="/checkout"],' +
        'form[action*="/checkout"] .add_to_cart,' +
        'form[action*="/cart"]#cart_form #checkout,' +
        'form[action*="/cart"] button.Cart__Checkout,' +
        'form[action*="/cart"] button.cart__checkout,' +
        'a.btn.disabled.ttmodalbtn[href="/checkout"],' +
        'form[action*="/cart"] [name="checkout"][type="submit"],' +
        'button.Cart__Checkout.Button.Button--primary.Button--full,' +
        '.baskettop button.mini-cart-checkout,' +
        '.tt-dropdown-menu .btn.itemCheckout,' +
        '.bss-btn-checkout-mini-cart,' +
        'button[name="checkout"].btn,' +
        'form[action*="/checkout"] [name="checkout"],' +
        '.cart__footer .cart__checkout-button.button,' +
        '#cartform #checkout,' +
        `#slidedown-cart button[onclick="window.location='/checkout'"],` +
        '#dropdown-cart button.btn.btn-checkout,' +
        '.button.checkout,' +
        'form[action*="/cart"] button[type="submit"].c-btn.c-btn--light.cart__button-update.update-cart,' +
        'form[action*="/cart"] .sp-proceed-to-checkout a[href="/checkout/"],' +
        '.bss-b2b-customer-portal-nt-checkout-btn,' +
        '.checkout-button.button.button--primary.button--full,' +
        '.button.cursor-pointer[name="checkout"],' +
        'form[action="/cart/add"] .product-form--atc .shopify-payment-button button.shopify-payment-button__button,' +
        'form[action*="/cart"] div.cart__checkout,' +
        'form[action*="/cart"] a[href="/cart"],' +
        '#header-mini-cart-footer > div > div.mini-cart-footer-actions > a,' +
        '#cart-checkout,' +
        '#CartDrawer-Checkout,' +
        '#checkout,' +
        '#CheckOut,' +
        'div.push-btn.inline-block,' +
        '.\\#cart-sidebar-checkout .\\#button,' +
        'form[action="/cart"] .\\#button,' +
        '.button.add_to_cart.checkout';
    
    BSS_BCP.helper.miniCartBtn = '.cart-popup a[href*="/cart"], #CartDrawer button[type="submit"], #ajaxifyCart button[type="submit"],' +
        '.button.checkout.wc-forward, .off-canvas--right-sidebar button[type="submit"][name="checkout"], .atc-banner--cart,' +
        '.button-primary.atc-button--checkout, .modal-footer .btn.btn-success.calltoaction.npopup-checkout, .button-group.button-group--loose.button-group--fit,' +
        '.btn.accent.cart__checkout, .rebuy-cart__flyout .rebuy-button.rebuy-cart__checkout-button, .mini-cart__footer .button-container button,' +
        '.Cart.Drawer__Content .Drawer__Footer button.Cart__Checkout.btn--primary, form[action="/cart"] button[type="submit"], .header-wrapper .mini-cart a[href*="/checkout"], .header-middle .mini-cart a[href*="/checkout"],' +
        '[name="checkout"], .ajax-success-modal.halo-modal a.btn.btn-checkout.show';

    BSS_BCP.helper.btnViewCart = 'form[action="/cart"] button[type="submit"], .cart-popup a[href*="/cart"], #CartDrawer button[type="submit"],' +
    '#ajaxifyCart button[type="submit"], .header-wrapper .mini-cart a[href*="/checkout"], .header-middle .mini-cart a[href*="/checkout"],' +
    '.button.checkout.wc-forward, [name="checkout"], .ajax-success-modal.halo-modal a.btn.btn-checkout.show, .rebuy-cart__flyout .rebuy-button.rebuy-cart__checkout-button'

    BSS_BCP.helper.addToCartVoDefault = '#shopify-section-product-template #AddToCart, .template-product .product-form__cart-submit, .template-product .product__content-main .btn.btn--full.product__add-to-cart-button.shopify-payment-btn,' +
    '#shopify-section-product-template .grid .grid-item.large--three-fifths #addToCart-product-template, #shopify-section-product-template #ProductSection--product-template #AddToCartForm--product-template #AddToCart--product-template,' +
    '#shopify-section-product-template .product .product__details.grid__item #AddToCart-product-template, .product.product--template .product__sticky .product-form__buttons .product-form__add-to-cart.button,' +
    '.page-width .product__info-container.product__info-container--sticky .product-form__buttons .product-form__submit.button, .page-width .product__info-container.product__column-sticky .product-form__buttons .product-form__submit.button,' +
    '.template-product .product-single__info-wrapper #AddToCart-product-template, .product-content-container .product-block-area .shopify-product-form .add-to-cart-container #addToCartButton, .bss-bcp-vo-add-to-cart'

    BSS_BCP.helper.productFormVoDefault = '.template-product .product-single__meta .product-form.product-form-product-template, #shopify-section-product-template .product-single__title,' +
    '.template-product .product-single__title, .template-product #shopify-section-product-template .product__content-main .product-form, #shopify-section-product-template .grid .grid-item.large--three-fifths h1.h2,' +
    '#shopify-section-product-template #ProductSection--product-template h1.product-single__title, #shopify-section-product-template .product .product__details.grid__item h1.h2,' +
    '.product.product--template .product__sticky h1#ProductHeading, .page-width .product__info-container.product__info-container--sticky h1.product__title, .template-product .product-single__info-wrapper .product-single__title,' +
    '#product-form-installment, .product__title, .product-content-container .product-block-area .shopify-product-form';

    BSS_BCP.helper.productPriceVoDefault = '.template-product .product__price, #shopify-section-product-template .product-single__prices, #shopify-section-product-template .grid .grid-item.large--three-fifths ul.inline-list.product-meta,' +
    '#shopify-section-product-template #ProductSection--product-template .price-container, #shopify-section-product-template .product .product__details.grid__item .product__price,' +
    '.product.product--template .product__sticky dl.price, .page-width .product__info-container.product__info-container--sticky .price, .page-width .product__info-container.product__column-sticky .price,' +
    '.template-product .product-single__info-wrapper .product-single__meta-list, .product__variants'

    BSS_BCP.helper.variantChoiceVoDefault = '.template-product .product-form__controls-group .selector-wrapper.js.product-form__item, #shopify-section-product-template .product-form--wide .selector-wrapper,' +
    '.template-product #ProductSection .grid.product-single .product-single__meta .product-form, .template-product .product__content-main .product-form .product-form__item.supports-js,' +
    '#shopify-section-product-template .grid .grid-item.large--three-fifths .selector-wrapper, #shopify-section-product-template #ProductSection--product-template #AddToCartForm--product-template .radio-wrapper.js.product-form__item,' +
    '#shopify-section-product-template .product .product__details.grid__item .selector-wrapper, .product.product--template .product__sticky .product-form__select.form__input-wrapper.form__input-wrapper--select,' +
    '.page-width .product__info-container.product__info-container--sticky variant-radios, .page-width .product__info-container.product__column-sticky variant-radios,' +
    '.page-width .product__info-container.product__info-container--sticky .product-form__input.product-form__quantity, .template-product .product-single__info-wrapper .selector-wrapper.js.product-form__item,' +
    '.template-product .product-single__info-wrapper .product-form__item.product-form__item--quantity, .product-form__action-wrapper .product-form--atc-button'

    BSS_BCP.helper.productQuantityVoDefault = 'form[action*="/cart/add"] .product-form__item, .product-form__input.product-form__quantity, .product-form__action-wrapper .quantity-selector__wrapper'

    BSS_BCP.helper.getAddToCartDefault = function () {
        let addToCartDefault = document.querySelectorAll(
            '.productView-action,' +
            '#shopify-section-product-template #AddToCart,' +
            '.template-product .product-form__cart-submit,' +
            '.template-product .product__content-main .btn.btn--full.product__add-to-cart-button.shopify-payment-btn,' +
            '#shopify-section-product-template .grid .grid-item.large--three-fifths #addToCart-product-template,' +
            '#shopify-section-product-template #ProductSection--product-template #AddToCartForm--product-template #AddToCart--product-template,' +
            '#shopify-section-product-template .product .product__details.grid__item #AddToCart-product-template,' +
            '.product.product--template .product__sticky .product-form__buttons .product-form__add-to-cart.button,' +
            '.page-width .product__info-container.product__info-container--sticky .product-form__buttons .product-form__submit.button,' +
            '.template-product .product-single__info-wrapper #AddToCart-product-template,' +
            '.product-content-container .product-block-area .shopify-product-form .add-to-cart-container #addToCartButton,' +
            '.product-form--atc .product-form--atc-button,' +
            '.product_single_detail_section #AddToCart,' +
            '.product-form-product--static .product-form__controls-group--submit .product-form__submit-button-wrapper .product-form__cart-submit,' +
            '.buy-buttons-row .button.button--large[type="submit"],' +
            '.tab-body .purchase-section button.btn.add-to-cart,' +
            '.product-form .product-form__payment-container,' +
            '.action_button.button--add-to-cart,' +
            'product-form div:nth-child(6) div button[type="submit"],' +
            '.product-form__submit.button.button--full-width.button--secondary,' +
            '.quick-add__submit.button.button--full-width.button--secondary,' +
            'product-form product-to-cart,' +
            '.button.button-add-to-cart.button-secondary,' +
            '.add_to_cart.global-button.global-button--primary.ajax-submit,' +
            '.product-form__buttons .product-form__buttons-row .product-form__submit.button'
        );
        return addToCartDefault;
    };
    BSS_BCP.helper.AddToCartDefaultElement = '#shopify-section-product-template #AddToCart,' +
        '.template-product .product-form__cart-submit,' +
        '.template-product .product__content-main .btn.btn--full.product__add-to-cart-button.shopify-payment-btn,' +
        '#shopify-section-product-template .grid .grid-item.large--three-fifths #addToCart-product-template,' +
        '#shopify-section-product-template #ProductSection--product-template #AddToCartForm--product-template #AddToCart--product-template,' +
        '#shopify-section-product-template .product .product__details.grid__item #AddToCart-product-template,' +
        '.product.product--template .product__sticky .product-form__buttons .product-form__add-to-cart.button,' +
        '.page-width .product__info-container.product__info-container--sticky .product-form__buttons .product-form__submit.button,' +
        '.template-product .product-single__info-wrapper #AddToCart-product-template,' +
        '.product-content-container .product-block-area .shopify-product-form .add-to-cart-container #addToCartButton,' +
        '.product-form--atc .product-form--atc-button,' +
        '.product_single_detail_section #AddToCart,' +
        '.product-form-product--static .product-form__controls-group--submit .product-form__submit-button-wrapper .product-form__cart-submit,' +
        '.buy-buttons-row .button.button--large[type="submit"],' +
        '.tab-body .purchase-section button.btn.add-to-cart,' +
        '.product-form .product-form__payment-container,' +
        '.action_button.button--add-to-cart,' +
        'product-form div:nth-child(6) div button[type="submit"],' +
        '.product-form__submit.button.button--full-width.button--secondary,' +
        '.quick-add__submit.button.button--full-width.button--secondary,' +
        '.quick-add.no-js-hidden [bss-bcp-quote-product-price]'
    BSS_BCP.helper.getBuyItNowBtn = function () {
        let buyItNowBtn = document.querySelectorAll(BSS_BCP.helper.buyItNowtElements);
        return buyItNowBtn;
    }
    BSS_BCP.helper.buyItNowtElements = '.template-product .shopify-payment-button .shopify-payment-button__button--unbranded:not([disabled]),' +
        '.page-width .product__info-container.product__info-container--sticky .product-form__buttons .shopify-payment-button,' +
        '.template-product .product-single__info-wrapper .shopify-payment-button,' +
        '.product-form--atc .shopify-payment-button,' +
        '.purchase-section .bottompad-half div[data-shopify="payment-button"],' +
        '.shopify-payment-button, form[action="/cart/add"] .product-form__button';

    BSS_BCP.helper.buyItNowBtnForVO = '.shopify-payment-button__button';
    
    BSS_BCP.helper.featuredCollectionSelector = function () {
        let featuredCollectionSelector = document.querySelectorAll(
            '.product-recommendations--section [bss-bcp-quote-product-price],' +
            '.product-recommendations [bss-bcp-quote-product-price],' +
            '.product-recently-viewed--section [bss-bcp-quote-product-price],' +
            //fix for bee-trade-buying-group by CuongNVM
            '.related-products-wrapper [bss-bcp-quote-product-price],' +
            '.featured-product [bss-bcp-quote-product-price], ' +
            '.collection [bss-bcp-quote-product-price],' +
            '.product-recommendations [bss-bcp-quote-product-price],' +
            '.related-products-wrapper [bss-bcp-quote-product-price],' +
            // fix for bathroom-warehouse-dev.myshopify.com by HauNT
            '.productgrid--item [bss-bcp-quote-product-price]'
        );
        return featuredCollectionSelector;
    };

    BSS_BCP.helper.recommendedProductSelector = function () {
        let recommendedProductSelector = document.querySelectorAll(
            '.product-recommendations--section [bss-bcp-quote-product-price],' +
            '.product-recommendations [bss-bcp-quote-product-price],' +
            '.product-recently-viewed--section [bss-bcp-quote-product-price],' +
            '.related-products [bss-bcp-quote-product-price]'
        );
        return recommendedProductSelector;
    };
    BSS_BCP.page = {};
    BSS_BCP.page.getPage = function () {
        var hrefArr = window.location.href.split("/");
        return hrefArr;
    };
    BSS_BCP.page.isCartPage = function () {
        var hrefArr = BSS_BCP.page.getPage();
        var isCart = (hrefArr[hrefArr.length - 1] == "cart" || (hrefArr[hrefArr.length - 1].includes("cart") && hrefArr[hrefArr.length - 2] !== "products") && hrefArr[hrefArr.length - 2] !== "collections");
        return isCart;
    };
    BSS_BCP.page.isCollectionPage = function () {
        var hrefArr = BSS_BCP.page.getPage();
        var isCollectionPage = hrefArr[hrefArr.length - 2] == "collections";
        return isCollectionPage;
    };
    BSS_BCP.page.isProductPage = function () {
        var hrefArr = BSS_BCP.page.getPage();
        var isProductPage = hrefArr[hrefArr.length - 2] == "products";
        return isProductPage;
    };
    BSS_BCP.page.isSearchPage = function () {
        var isSearchPage = window.location.pathname == "/search";
        return isSearchPage;
    };
    BSS_BCP.page.isHomePage = function () {
        var isHomePage = window.location.pathname == "/";
        return isHomePage;
    };
}

// CONCATENATED MODULE: ./src/js/src/helper/format-money.js
function formatMoney(shopData, BSS_BCP) {
    BSS_BCP.money_format = shopData.shop.money_format;
    BSS_BCP.formatMoney = function (cents, format) {
        if (typeof cents == 'string') {
            cents = cents.replace('.', '');
        }
        let value = '';
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        let formatString = (format || BSS_BCP.money_format || this.money_format);
        let formatElement = [
            "<span class=money>",
            "</span>",
            "<div class=dualPrice>",
            "</div>",
            "<span class=dualPrice>",
            "<span class=hidePrice>"
        ];

        for (let i = 0; i < formatElement.length; i++) {
            if (formatString.includes(formatElement[i])) {
                formatString = formatString.replace(formatElement[i], "");
            }
        }

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            let parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    };
}

// CONCATENATED MODULE: ./src/js/src/nt/custom/main.js


const customBcpNetterm = (BSS_BCP) => {
    // Default
    BSS_BCP.netterm.showButtonOnCartPage();

    // setTimeout
    // Store: belltentvillage.myshopify.com uninstall app => remove
    if ([1478, 3086].includes(BSS_BCP.storeId) || ['kbgolf.com'].includes(window.location.hostname)) {
        setTimeout(() => {
            BSS_BCP.netterm.showButtonOnCartPage();
        }, 2500)
    }
    if ([2469].includes(BSS_BCP.storeId)) {
        setTimeout(() => {
            let  addToCart = document.querySelector('.product-form__action-wrapper .product-form--atc-button')
             if (addToCart) {
                addToCart.addEventListener("click", ()=>{
                    setTimeout(() => {
                        let nettermButton = document.querySelector('.atc-banner--cart-footer .bss-b2b-customer-portal-nt-checkout-btn ')
                        if (nettermButton) {
                            nettermButton.addEventListener("click", ()=> {
                                BSS_BCP.netterm.validateProductBeforePurchaseLate();
                                handleSaveCartNote();
                            })
                        }
                    }, 1500)
                })
            }
        }, 2000)
    }

    // add eventListener
    if (window.location.hostname === 'colorado-food-showroom.myshopify.com') {
        document.addEventListener('ARMADA:CART:COUNT:CHANGE', () => {
            BSS_BCP.netterm.showButtonOnCartPage();
        });
    }
    if ([1532, 1830].includes(BSS_BCP.storeId)) {
        document.addEventListener('closeFlyouts', () => {
            BSS_BCP.netterm.showButtonOnCartPage();
        });
    }
    if ([2431].includes(BSS_BCP.storeId)) {
        document.addEventListener('bss:custom:minicart-open', () => {
            BSS_BCP.netterm.showButtonOnCartPage();
        });
    }

    // mutation
    if ([2094, 1559, 2640, 2083].includes(BSS_BCP.storeId)) {
        let cartElement = document.querySelector('.\\#modal-popup-content, #dropdown-cart .has-items .actions, .cart-section aside #AjaxCartSubtotal, sidebar-drawer .sidebar__body #AjaxCartForm');

        if (cartElement) {
            const observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (m) {
                    if (m.addedNodes.length) {
                        if (BSS_BCP.storeId === 1559) {
                            const ntButton = cartElement.querySelector('.btn.btn-checkout.bss-b2b-customer-portal-nt-checkout-btn')
                            if (ntButton) {
                                ntButton.addEventListener('click', function () {
                                    BSS_BCP.netterm.getCartData(false);
                                })
                            }
                        } else {
                            BSS_BCP.netterm.showButtonOnCartPage();
                        }
                    }
                });
            });
            observer.observe(cartElement, { childList: true });
        }
    }
    if ([2009, 1157, 1555].includes(BSS_BCP.storeId)) {
        let cartElement = document.querySelector('cart-drawer.cart-drawer.drawer, #HeaderMiniCart, #MainContent, #mini-cart > div.ajax-cart__header-wrapper.grid__wrapper.edge > div.span-4.sm-span-4.auto.a-right.v-center > p > .js-cart-count.inline-block,' +
            '.cart-page.ajax-cart__page-wrapper.cart-type--drawer.main__section .ajax-cart__header-wrapper.grid__wrapper.edge .js-cart-count, #main'
        );

        if (cartElement) {
            const observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (m) {
                    if (m.addedNodes.length) {
                        BSS_BCP.netterm.showButtonOnCartPage();
                    }
                });
            });
            observer.observe(cartElement, { childList: true, subtree: true });
        }
    }

    // Other
    if ([1945].includes(BSS_BCP.storeId)) {
        let due_days = 7;
        if (BSS_BCP.nt.rules.length) {
            due_days = BSS_BCP.nt.rules[0].due_days;
        }
        let currentDate = new Date();
        let futureDate = new Date();
        futureDate.setDate(currentDate.getDate() + due_days);
        let options = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' };
        let formattedDate = futureDate.toLocaleDateString('en-US', options).replaceAll(",", "");
        let CustomDiv = document.createElement("div");
        CustomDiv.className = "bss_custom";
        CustomDiv.style.textAlign = "center"
        let customDivContent = document.createTextNode(`Your payment is due on ${formattedDate}`);
        CustomDiv.appendChild(customDivContent);
        if (window.location.pathname === '/cart') {
            let textCart = document.querySelector('.cart__item-row.text-center');
            let cartPageCol = document.querySelectorAll('.cart__page-col')[1];
            if (cartPageCol && textCart) {
                cartPageCol.appendChild(CustomDiv);
            }
        } else {
            let cartDraw = document.querySelector('#CartDrawerForm');
            let textCart = document.querySelector('.cart__item-row.text-center');
            if (cartDraw && textCart) {
                textCart.insertAdjacentElement('afterend', CustomDiv);
            }
        }
    }
    if (BSS_BCP.storeId === 1901) {
        if (BSS_BCP.configData.nt_replace_checkout && window.location.pathname.includes('/apps/customer-portal/quick-order')) {
            let handleRemoveCheckoutButton = setInterval(function () {
                let checkoutButtonSelector = document.querySelector('#bss-bcp-qo-checkout-btn');
                if (checkoutButtonSelector) {
                    checkoutButtonSelector.remove();
                    setTimeout(function () {
                        clearInterval(handleRemoveCheckoutButton);
                    }, 500);
                }
            }, 50);

            setTimeout(function () {
                clearInterval(handleRemoveCheckoutButton);
            }, 2000);
        }
    }
    if (BSS_BCP.storeId === 885) {
        setTimeout(() => {
            BSS_BCP.netterm.showButtonOnCartPage();
        }, 3000)

        setTimeout(() => {
            let addToCartBtn = document.querySelectorAll('form[action="/cart/add"] .product-form--atc .product-form--atc-button')
            if (addToCartBtn.length) {
                for (let i = 0; i < addToCartBtn.length; i++) {
                    let addToCartBtn = addToCartBtn[i];
                    addToCartBtn.onclick = () => {
                        setTimeout(() => {
                            BSS_BCP.netterm.showButtonOnCartPage();
                        }, 1500)
                    }
                }
            }
        }, 3500)
    }
    if (BSS_BCP.storeId === 2144) {
        setTimeout(() => {
            BSS_BCP.netterm.showButtonOnCartPage();
        }, 2000);
        customChangeQtyForStore();
    }
    if (BSS_BCP.storeId === 885) {
        setTimeout(() => {
            BSS_BCP.netterm.showButtonOnCartPage();
        }, 3000)

        setTimeout(() => {
            const addToCartBtn = document.querySelectorAll('form[action="/cart/add"] .product-form--atc .product-form--atc-button');
            if (addToCartBtn.length) {
                for (let i = 0; i < addToCartBtn.length; i++) {
                    const addToCartBtn = addToCartBtn[i];
                    addToCartBtn.onclick = () => {
                        setTimeout(() => {
                            BSS_BCP.netterm.showButtonOnCartPage();
                        }, 1500)
                    }
                }
            }
        }, 3500)
    }
    if (BSS_BCP.storeId === 1792) {
        const addToCartBtnList = document.querySelectorAll('form[action="/cart/add"] .product-form--atc .product-form--atc-button,.productitem--action-trigger.productitem--action-atc')
        if (addToCartBtnList.length) {
            for (let i = 0; i < addToCartBtnList.length; i++) {
                const addToCartBtn = addToCartBtnList[i];
                addToCartBtn.addEventListener('click', () => {
                    const interval = setInterval(() => {
                        const checkoutPopup = document.querySelector('.site-header-nav--open .button-primary.atc-button--checkout');
                        if (checkoutPopup) {
                            checkoutPopup.style.pointerEvents = 'none';
                        }
                    }, 200)
                    setTimeout(() => {
                        clearInterval(interval);
                        BSS_BCP.netterm.showButtonOnCartPage();
                    }, 2500)
                })
            }
        }
    }

    if (BSS_BCP.storeId === 3054) {
        const toggleMiniCart = document.querySelectorAll('#nav-user li.cart, button[type="submit"].overlay-tertiary');
        toggleMiniCart.forEach(element => {
            element.addEventListener('click', () => {
                setTimeout(() => {
                    BSS_BCP.netterm.showButtonOnCartPage()
                }, 700)
                const myInterval = setInterval(() => {
                    const payLaterBtn = document.querySelector('.overlay-tertiary.ajax-cart__toggle.bss-b2b-customer-portal-nt-checkout-btn');
                    if (payLaterBtn) {
                        payLaterBtn.addEventListener('click', () => {
                            BSS_BCP.netterm.validateProductBeforePurchaseLate();
                            handleSaveCartNote();
                        })
                        clearInterval(myInterval);
                    }
                }, 300);
            })
        });
    }

    if (window.location.hostname === 'tooldepotno.myshopify.com') {
        setTimeout(() => {
            const addToCartBtn = document.querySelector('form[action="/cart/add"] .product-form--atc .product-form--atc-button');
            if (addToCartBtn) {
                addToCartBtn.onclick = () => {
                    const purchaseLaterBtn = document.querySelectorAll(".bss-b2b-customer-portal-nt-checkout-btn");
                    if (purchaseLaterBtn && purchaseLaterBtn.length) {
                        purchaseLaterBtn.forEach(purchaseLaterBtn => {
                            purchaseLaterBtn.remove();
                        })
                    }
                    setTimeout(() => {
                        BSS_BCP.netterm.showButtonOnCartPage();
                    }, 1500)
                }
            }
        }, 1000)
    }
}

const customButtonCheckout = (BSS_BCP, checkoutBtn) => {
    // check by hostname or storeId (recommend storeId and query unique)
    if (window.location.hostname === 'www.canterburycanada.com') {
        checkoutBtn = document.querySelectorAll('button#checkout.add_to_cart.checkout');
    }
    if (window.location.hostname === 'www.platinumprotectors.com') {
        checkoutBtn = document.querySelectorAll('button[name="checkout"]');
    }
    if (window.location.hostname === 'www.arkcolourdesign.com') {
        checkoutBtn = document.querySelectorAll('#AjaxCartSubtotal .button.button--solid');
    }
    if (window.location.hostname === 'wexfordhomegoods.com') {
        checkoutBtn = document.querySelectorAll(`[name='checkout']:not([bss-b2b-create-draft-order])`);
    }

    // Store montikids.com: uninstall app => remove
    return checkoutBtn;
}

const customLabelCartNote = (BSS_BCP, labelCartNoteDefault, labelCartNoteCustom) => {
    if (labelCartNoteDefault) {
        if (BSS_BCP.storeId === 1792) {
            return `Delivery Note`;
        }
    }
    if (labelCartNoteCustom) {
        if (BSS_BCP.storeId === 1792) {
            return `Order Reference`;
        }
    }
    return false;
}

const eventFromB2B = (BSS_B2B, BSS_BCP) => {
    if (["pointoneb2b.com"].includes(window.location.hostname)) {
        if (!BSS_B2B.qi || !BSS_B2B.qi.invalidIncrementProducts) {
            BSS_BCP.netterm.validateProductBeforePurchaseLate();
        }
    }
}

const customCheckExistBtn = (checkExistNtBtn) => {
    if (window.location.hostname === 'beetbg.com') {
        checkExistNtBtn = false;
    }
    return checkExistNtBtn;
}

const customCheckoutNT = (BSS_BCP) => {
    if ([1532, 1830, 1792].includes(BSS_BCP.storeId)) {
        const btnCheckoutNT = $('.bss-b2b-customer-portal-nt-checkout-btn');
        btnCheckoutNT.off('click');
        btnCheckoutNT.on('click', () => {
            BSS_BCP.netterm.validateProductBeforePurchaseLate();
        });
    }
}

const customDisplayBtn = (checkoutBtn) => {
    if (window.location.hostname === 'parkstyling.com') {
        if (checkoutBtn.closest('form[action*="/cart"]')) {
            checkoutBtn.closest('form[action*="/cart"]').setAttribute("bss-fix-button-nt", "");
        } else if (checkoutBtn.closest('#mini-cart')) {
            checkoutBtn.closest('#mini-cart').setAttribute("bss-fix-button-nt", "");
        }
    } else if (window.location.hostname === 'palapets.com') {
        document.addEventListener("bss_b2b_doneCheckCp", () => {
            checkoutBtn.style.display = 'none';
        })
    } else {
        checkoutBtn.style.display = 'none';
    }
}

const customPositionNTBtn = (checkoutBtn, checkoutNtBtn, index) => {
    if (window.location.hostname === 'colorado-food-showroom.myshopify.com') {
        let inputNumber = document.querySelectorAll('.cart-main input[type="number"]')
        if (inputNumber.length) {
            inputNumber.forEach((e) => {
                e.addEventListener("keydown", function (event) {
                    if (event.keyCode === 13) {
                        event.preventDefault();
                        e.blur();
                    }
                });
            })
        }
    }
    // Store gposavings.myshopify.com => uninstall app => remove code
    // Store palomaliving.com: uninstall app => remove

    // main

    checkoutBtn[index].after(checkoutNtBtn);
}

const customChangeQtyForStore = () => {
    setTimeout(function () {
        const handleChangeQuantity = function () {
            let checkoutFake = document.querySelector('form[action*="/cart"] a[href="/cart"]');
            if (checkoutFake && window.location.pathname === '/cart') {
                checkoutFake.style.display = 'none';
            }
            if (window.location.hostname === 'organicbeer.it') {
                let handleRemoveCheckout = setInterval(() => {
                    let checkoutBtn = document.querySelectorAll('form[action*="/cart"] a[href="/cart"],.push-btn.inline-block.relative.w-full ');
                    if (checkoutBtn.length > 1) {
                        for (let i = 2; i < checkoutBtn.length; i++) {
                            checkoutBtn[i].remove();
                        }
                    }
                    clearInterval(handleRemoveCheckout)
                }, 50);
                setTimeout(() => {
                    clearInterval(handleRemoveCheckout)
                }, 2000)
            }
            let quantityButtonSelector = document.querySelectorAll('#shopping-cart .ajax-cart__qty-control--up, #shopping-cart .ajax-cart__qty-control--down, form[action="/cart"] .ajax-cart__qty-control--up, form[action*="/cart"] .ajax-cart__qty-control--down,.max-w-min .w-8.h-full');
            let quantityInputSelector = document.querySelectorAll('#shopping-cart .ajax-cart__qty-input, form[action="/cart"] .ajax-cart__qty-input,.text-center.bg-transparent,.quantity__input');
            let removeCartItemBtn = document.querySelectorAll('#shopping-cart .ajax-cart__item-remove--js, form[action="/cart"] .ajax-cart__item-remove--js,.max-w-min p.text-xs,.delete-product');
            function handleCustomNT() {
                const handleHideCheckoutBtn = setInterval(() => {
                    let viewCart = document.querySelectorAll('.button-container .button.button--secondary,.bss-b2b-customer-portal-nt-checkout-btn-default,.button-container button.button:not(.bss-b2b-customer-portal-nt-checkout-btn)');
                    if (viewCart.length) {
                        viewCart.forEach(item => {
                            item.style.display = 'none';
                        })
                    }
                }, 100);
                setTimeout(() => {
                    clearInterval(handleHideCheckoutBtn);
                }, 4000)
            }
            if (quantityButtonSelector && quantityButtonSelector.length) {
                for (let i = 0; i < quantityButtonSelector.length; i++) {
                    quantityButtonSelector[i].addEventListener("click", () => {
                        if (window.location.hostname === 'montikids.com') {
                            handleCustomNT();
                        }
                        setTimeout(function () {
                            BSS_BCP.netterm.showButtonOnCartPage();
                            handleChangeQuantity();
                        }, 2500)
                    })
                }
            }
            if (quantityInputSelector && quantityInputSelector.length) {
                for (let i = 0; i < quantityInputSelector.length; i++) {
                    if (window.location.hostname === 'montikids.com') {
                        handleCustomNT();
                    }
                    quantityInputSelector[i].onchange = function () {
                        setTimeout(function () {
                            BSS_BCP.netterm.showButtonOnCartPage();
                            handleChangeQuantity();
                        }, 2500)
                    }
                }
            }
            if (removeCartItemBtn && removeCartItemBtn.length) {
                for (let i = 0; i < removeCartItemBtn.length; i++) {
                    if (window.location.hostname === 'montikids.com') {
                        handleCustomNT();
                    }
                    removeCartItemBtn[i].onclick = function () {
                        setTimeout(function () {
                            BSS_BCP.netterm.showButtonOnCartPage();
                            handleChangeQuantity();
                        }, 2500)
                    }
                }
            }
        }
        handleChangeQuantity();
    }, 2000)
}

const defineNtBtn = (checkoutNtBtn, className, id, valueTranslation, btnText) => {
    checkoutNtBtn.className = className + ' bss-b2b-customer-portal-nt-checkout-btn';
    checkoutNtBtn.value = valueTranslation;
    checkoutNtBtn.id = id;
    checkoutNtBtn.type = 'button';
    checkoutNtBtn.name = 'checkout';
    checkoutNtBtn.appendChild(btnText);
}

const customTextModal = (bssPurchaseLateTranslation) => {
    if (window.location.hostname === 'tooldepotno.myshopify.com') {
        const elementPurchaseRuleName = document.querySelector(".bss-purchase-late-rule-name");
        if (elementPurchaseRuleName) {
            elementPurchaseRuleName.innerHTML = bssPurchaseLateTranslation["purchase_late_note"];
        }
    }
}
// CONCATENATED MODULE: ./src/js/src/nt/action.js


const handleSaveCartNote = () => {
    let contentCartNote = '';
    let additionalDetails = [];
    const isAddNote = [855, 2144];
    const isAddAdditionDetail = [1792];
    if ([...isAddNote, ...isAddAdditionDetail].includes(BSS_BCP.storeId)) {
        let cartNoteDefault = document.querySelectorAll(`.cart-total textarea:not(.bss-b2b-cart-note), #cialInstructions`);
        let cartNoteCustom = document.querySelectorAll(`.bss-b2b-custom-fields textarea`);
        if (cartNoteDefault.length) {
            cartNoteDefault.forEach(note => {
                if (note.value) {
                    contentCartNote += `${note.value}, `;
                    let customLabel = customLabelCartNote(BSS_BCP, true, false) ? customLabelCartNote(BSS_BCP, true, false) : 'cart note';
                    additionalDetails.push({
                        key: customLabel,
                        value: note.value
                    })
                }
            })
        }
        if (cartNoteCustom.length) {
            cartNoteCustom.forEach(note => {
                if (note.value) {
                    contentCartNote += `${note.value}, `;
                    let customLabel = customLabelCartNote(BSS_BCP, false, true) ? customLabelCartNote(BSS_BCP, false, true) : note.className;
                    additionalDetails.push({
                        key: customLabel,
                        value: note.value
                    })
                }
            })
        }
        if (contentCartNote) {
            contentCartNote = contentCartNote.slice(0, -2);
        }
    }
    if (contentCartNote && isAddNote.includes(BSS_BCP.storeId)) {
        localStorage.setItem('cart-note-for-bcp', contentCartNote);
    }
    if (additionalDetails.length && isAddAdditionDetail.includes(BSS_BCP.storeId)) {
        localStorage.setItem('cart-addtionaldetails-for-bcp', JSON.stringify(additionalDetails));
    }
}

const handleClickPurchaseLate = (id, rule = {}, isMultipleBtn = false) => {
    if (isMultipleBtn) {
        localStorage.setItem('bssBCPNtId', id);
        localStorage.setItem('bssBCPNTChoose', JSON.stringify(rule));
    }
    if ([1542].includes(BSS_BCP.storeId)) {
        eventFromB2B(BSS_B2B, BSS_BCP);
    } else {
        BSS_BCP.netterm.validateProductBeforePurchaseLate();
        handleSaveCartNote();
    }
}

const showPopup = (popup) => {
    const _popup = document.querySelector(`.popup.${popup}`);
    const _popupClose = document.querySelector(`.popup-close.${popup}`);
    if (_popup) {
        _popup.style.display = 'block';
    }
    if (_popupClose) {
        _popupClose.onclick = function () {
            _popup.style.display = 'none';
        }
    }
}

/**
 * @description Handle event click from B2B
 * @param checkoutBtn
 * @param rule
 * @param multipleBtn
 * @returns {void}
 */
const handleEventFromB2B = (checkoutNtBtn, rule, isMultipleBtn = false) => {
    if ((typeof (BSS_B2B) != 'undefined') && BSS_B2B) {
        let isEnableAMO = false;
        if (BSS_B2B.shopModules && (BSS_B2B.shopModules.length > 0)) {
            BSS_B2B.shopModules.forEach(function (sm) {
                if (sm.code == "amo") {
                    isEnableAMO = sm.status;
                }
            })
        }
        if (isEnableAMO && BSS_B2B.amoRules && !BSS_B2B.amoRules.length) {
            checkoutNtBtn.onclick = function () {
                const id = this.id.toString().replace("bss-nt-purchase-late-", "");
                handleClickPurchaseLate(id, rule, isMultipleBtn);
            }
        }
        document.addEventListener("bss.b2b.amo.doneCheckAMOByBSS", function () {
            if (isEnableAMO && BSS_B2B.amo && BSS_B2B.amo.warning && BSS_B2B.amo.warning.length > 0) {
                checkoutNtBtn.onclick = function () {
                    BSS_B2B.amo.showWarningsModal();
                    return false;
                }
            } else {
                checkoutNtBtn.onclick = function () {
                    const id = this.id.toString().replace("bss-nt-purchase-late-", ""); // id co the co gia tri or 0
                    handleClickPurchaseLate(id, rule, isMultipleBtn);
                }
            }
        })
    }
}

/**
 * @description Handle remove product do not apply rule
 * @param products
 * @returns {void}
 */
const handleRemoveProduct = async (listKey, validNtProductNtRule, ntApply, ruleNtApply, invalidRuleNtApply) => {
    if (ntApply !== 2) {
        if (!ruleNtApply) {
            ruleNtApply = invalidRuleNtApply;
        }
    }
    let itemUpdate = {}
    listKey.map((item) => {
        let variantId = item.key.split(':')[0];
        itemUpdate[variantId] = 0;
    });
    if (!validNtProductNtRule.length) {
        if (itemUpdate.length) {
            await BSS_BCP.helper.updateCart(itemUpdate);
        }
    }
    window.location = '/apps/customer-portal/purchase-late'
}

/**
 * @description Handle show popup
 * @param productInvalidRule
 * @param productValidRule
 * @returns {void}
 */
const handleShowPopup = (BSS_BCP, invalidNT, validNtProductNtRule, ntApply, ruleNtApply, invalidRuleNtApply) => {
    const nameListStr = BSS_BCP.helper.getProductNameList(invalidNT);
    const elementInvalidProduct = document.querySelector('.invalid-netterm-product');
    const elementProcessNT = document.querySelector('.bss-proceed-to-purchase-late');
    if (elementInvalidProduct) {
        elementInvalidProduct.innerHTML = nameListStr;
    }
    showPopup('popup-validate-product');
    if (elementProcessNT) {
        elementProcessNT.onclick = function () {
            handleRemoveProduct(invalidNT, validNtProductNtRule, ntApply, ruleNtApply, invalidRuleNtApply);
        }
    }
}
// CONCATENATED MODULE: ./src/js/src/nt/checkEntity.js

/**
 * @description Check product
 * @param rule
 * @param cartItem
 * @returns {boolean}
 */
const checkProduct = (rule, item) => {
    let conditionType = rule ? rule.product_condition_type : null;
    let ruleTags = rule ? rule.product_tags : [];
    let specificProductIds = rule.product_ids;
    let ruleCollectionIds = rule.product_collections;
    ruleTags = ruleTags ? ruleTags.split(",") : [];
    specificProductIds = specificProductIds ? specificProductIds.split(",") : [];
    ruleCollectionIds = ruleCollectionIds ? ruleCollectionIds.split(",") : [];

    let productId = item.product_id ? item.product_id : item.id;
    let collections = item ? item.collections : [];
    let tags = item ? item.tags : [];

    if (conditionType == 0) {
        return true;
    } else if (conditionType == 1) {
        if (specificProductIds.indexOf(productId + "") !== -1) {
            return true;
        }
    } else if (conditionType == 2) {
        let checkArray = collections.filter(collection => ruleCollectionIds.includes(collection + ""));
        if (checkArray.length > 0) {
            return true;
        }
    } else if (conditionType == 3) {
        let checkArray = ruleTags.filter(tag => tags.includes(tag + ""));
        if (checkArray.length > 0) {
            return true;
        }
    }
    return false;
}

/**
 * @description Check customer
 * @param rule
 * @param customer
 * @returns {boolean}
 */
const checkCustomer = (rule, customer) => {
    let applyTo = rule.apply_to;
    let customerIds = rule.customer_ids;
    let customerTags = rule.customer_tags;

    if (applyTo === 0) { // all
        return true;
    } else if (applyTo === 1) { // specific customer
        customerIds = customerIds ? customerIds.split(',') : [];
        if (customerIds.includes(customer.id + "")) {
            return true;
        }
    } else if (applyTo === 2) { // customer tags
        customerTags = customerTags.split(",").map((tag) => tag.toLowerCase().trim());
        let tagsOfCustomer = customer.tags.map((tag) => {
            return tag.toLowerCase().trim();
        });
        let checkArray = customerTags.filter((tag) =>
            tagsOfCustomer.includes(tag),
        );
        if (checkArray.length !== 0) {
            return true;
        }
    } else if (applyTo === 3) { // customer logged in
        if (customer.id) {
            return true;
        }
    }
    return false;
}

/**
 * @description Check rule apply
 * @returns {boolean}
 */
const checkRuleNtApply = (customer, ruleNtApply) => {
    const ruleId = localStorage.getItem('bssBCPNtId');
    const ruleApply = BSS_BCP.nt.rules.filter(rule => +ruleId === rule.id);
    const customerId = customer.id;
    const customerTag = customer.tags;
    if (ruleApply.length) {
        const rule = ruleApply[0];
        const ruleCustomerIds = rule.customer_ids ? rule.customer_ids.split(',') : [];
        const ruleCustomerTags = rule.customer_tags ? rule.customer_tags.toLowerCase().split(',') : [];
        if (rule.apply_to == 0) {
            ruleNtApply = rule;
            return {
                isApplyRule: true,
                rule: ruleNtApply
            };
        }
        if ((rule.apply_to == 1) && customerId && (ruleCustomerIds.indexOf(customerId.toString()) !== -1)) {
            ruleNtApply = rule;
            return {
                isApplyRule: true,
                rule: ruleNtApply
            };
        }
        if ((rule.apply_to == 2) && customerTag.length > 0) {
            for (const ruleCustomerTag of ruleCustomerTags) {
                for (const tag of customerTag) {
                    if (tag.toLowerCase() === ruleCustomerTag) {
                        ruleNtApply = rule;
                        return {
                            isApplyRule: true,
                            rule: ruleNtApply
                        };
                    }
                }
            }
        }
        if (rule.apply_to == 3 && customerId) {
            ruleNtApply = rule;
            return {
                isApplyRule: true,
                rule: ruleNtApply
            };
        }
    }
    // eslint-disable-next-line
    ruleNtApply = ruleApply.length ? ruleApply[0] : null;
    return {
        isApplyRule: false,
        rule: ruleNtApply
    };
}

/**
 * @description Check product for purchase late
 * @param product
 * @returns {boolean}
 */
const checkProductPurchaseLate = (productData, ruleNtApply, invalidRuleNtApply) => {
    if (!Object.keys(ruleNtApply).length) {
        ruleNtApply = invalidRuleNtApply;
    }

    let conditionType = ruleNtApply ? ruleNtApply.product_condition_type : null;
    let specificProductIds = ruleNtApply.product_ids;
    let ruleTags = ruleNtApply ? ruleNtApply.product_tags : '';
    let ruleCollectionIds = ruleNtApply.product_collections;
    ruleTags = ruleTags ? ruleTags.split(",") : [];
    specificProductIds = specificProductIds ? specificProductIds.split(",") : [];
    ruleCollectionIds = ruleCollectionIds ? ruleCollectionIds.split(",") : [];

    let productId = productData.product_id ? productData.product_id : "";
    let collections = productData.collections ? productData.collections : [];
    let tags = productData ? productData.tags : '';

    if (conditionType == 0) {
        return true;
    } else if (conditionType == 1) {
        if (specificProductIds.indexOf(productId + "") !== -1) {
            return true;
        }
    } else if (conditionType == 2) {
        let checkArray = collections.filter(collection => ruleCollectionIds.includes(collection + ""))
        if (checkArray.length > 0) {
            return true;
        }
    } else if (conditionType == 3) {
        let checkArray = ruleTags.filter(tag => tags.includes(tag + ""))
        if (checkArray.length > 0) {
            return true;
        }
    }
    return false;
}

/**
 * @description Handle check rule for customer, product
 * @param products
 * @returns {void}
 */
const checkRuleForCustomerAndProduct = (BSS_BCP, productMap, ntApply, customer) => {
    let ruleNtApply = {}, invalidRuleNtApply = {};
    if (ntApply === 2) {
        let ruleId = localStorage.getItem('bssBCPNtId');
        let ruleApply = {};
        BSS_BCP.nt.rules.map(rule => {
            if (ruleId == rule.id) {
                ruleApply = rule;
            }
        });
        if (checkCustomer(ruleApply, customer)) {
            for (let j = 0; j < productMap.length; j++) {
                let item = productMap[j];
                if (checkProduct(ruleApply, item)) {
                    ruleNtApply = ruleApply;
                } else {
                    invalidRuleNtApply = ruleApply;
                    break;
                }
            }
        } else {
            invalidRuleNtApply = ruleApply;
        }
    }
    else {
        let listRuleFinal = [];
        let listRuleApplyCustomer = [];
        let listRuleError = [];
        let mapRuleById = new Map();
        let commonRule = new Map();
        for (let i = 0; i < BSS_BCP.nt.rules.length; i++) {
            let rule = BSS_BCP.nt.rules[i];
            mapRuleById.set(rule.id, rule);
            if (checkCustomer(rule, customer)) {
                listRuleApplyCustomer.push(rule);
                if (productMap && productMap.length) {
                    for (let j = 0; j < productMap.length; j++) {
                        let item = productMap[j];
                        if (checkProduct(rule, item)) {
                            let valueCommonRule = commonRule.get(rule.id)
                            if (valueCommonRule && valueCommonRule.length) {
                                valueCommonRule = [...valueCommonRule, item.product_id];
                            } else {
                                valueCommonRule = [item.product_id];
                            }
                            commonRule.set(rule.id, valueCommonRule);
                        }
                    }
                }
            } else {
                listRuleError.push(rule);
            }
        }

        // eslint-disable-next-line
        for (const [key, value] of commonRule.entries()) {
            let ruleApply = mapRuleById.get(key);
            listRuleFinal = [...listRuleFinal, ruleApply]
        }
        listRuleFinal = listRuleFinal.sort((a, b) => a.priority - b.priority);
        if (listRuleFinal.length) {
            ruleNtApply = listRuleFinal[0];
            localStorage.setItem('bssBCPNtId', ruleNtApply.id);
        } else {
            let listRuleCheck = listRuleApplyCustomer.length > 0 ? listRuleApplyCustomer : listRuleError;
            let ruleChoice = listRuleCheck[0];
            for (let i = 1; i < listRuleCheck.length; i++) {
                let currentRule = listRuleCheck[i];
                if (ruleChoice.priority > currentRule.priority) {
                    ruleChoice = currentRule;
                } else if (ruleChoice.priority === currentRule.priority) {
                    if (Date.parse(ruleChoice.createdAt) > Date.parse(currentRule.createdAt)) {
                        ruleChoice = currentRule;
                    }
                }
            }
            invalidRuleNtApply = ruleChoice;
            localStorage.setItem('bssBCPNtId', invalidRuleNtApply.id);
        }
    }
    return {
        _ruleNtApply: ruleNtApply,
        _invalidRuleNtApply: invalidRuleNtApply
    }
}
// CONCATENATED MODULE: ./src/js/src/nt/render.js



const showPurchaseLateBtn = (BSS_BCP, customer, ntApply) => {
    let isShowBtn = false;
    if ([1, 2].includes(ntApply)) {
        isShowBtn = true;
    } else if (ntApply === 0) {
        let _ntApply = new Map();
        let listNTApply = [];
        let listNTApplyCustomerIds = [];
        let listNTApplyCustomerTags = [];

        BSS_BCP.nt.rules.forEach(rule => {
            _ntApply.set(rule.id, rule.apply_to);
            if (rule.apply_to == 1) {
                listNTApplyCustomerIds = [...listNTApplyCustomerIds, ...rule.customer_ids.split(',')];
            } else if (rule.apply_to == 2) {
                listNTApplyCustomerTags = [...listNTApplyCustomerTags, ...rule.customer_tags.split(',')];
            }
        })

        _ntApply = new Map([..._ntApply.entries()].sort((a, b) => a[1] - b[1]));
        for (const [key, value] of _ntApply.entries()) {
            BSS_BCP.nt.rules.forEach(rule => {
                if (rule.status && [0, 1, 2, 3].includes(+value) && rule.id === key) {
                    listNTApply.push(rule.apply_to);
                    return;
                }
            })
        }

        if (customer.id) {
            for (let i = 0; i < listNTApply.length; i++) {
                const item = listNTApply[i];
                if (item === 3) {
                    if (customer.id) {
                        isShowBtn = true;
                    }
                    if (i === 0) {
                        break;
                    }
                } else {
                    if (item === 0) {
                        isShowBtn = true;
                    } else if (item === 1) {
                        if (listNTApplyCustomerIds.includes(customer.id.toString())) {
                            isShowBtn = true;
                        }
                    } else if (item === 2) {
                        listNTApplyCustomerTags.map(tag => {
                            if (customer.tags.includes(tag)) {
                                isShowBtn = true;
                            }
                        })
                    }
                }
            }
        } else {
            listNTApply.map(item => {
                if (item === 0) {
                    isShowBtn = true;
                }
            })
        }
    }

    return isShowBtn;
}

const definePopup = (bssPurchaseLateTranslation) => {
    // Define popup
    const popupHtml = `
                <div class="popup popup-validate-product" data-popup="popup-1">
                    <div class="popup-inner">
                        <h2 class="bss-purchase-late-note">Purchase Late Note</h2>
                        <div class="popup-scroll">
                            <span><p class="invalid-netterm-product"></p></span>
                            <span class="invalid-netterm-product-message"><p></p></span>
                        </div>
                        <p><a class="bss-proceed-to-purchase-late" href="#">Proceed to purchase late page</a></p>
                        <a class="popup-close popup-validate-product" data-popup-close="popup-1" href="#">x</a>
                    </div>
                </div>
            `;
    const popupMultiButton = `
                <div class="popup popup-multi-button" data-popup="popup-2">
                    <div class="popup-inner">
                        <h2 class="bss-purchase-late-rule-name">Purchase Late Note</h2>
                        <div class="popup-scroll">
                            <span class="invalid-netterm-rule-message"></span>
                        </div>
                        <a class="popup-close popup-multi-button" data-popup-close="popup-2" href="#">x</a>
                    </div>
                </div>
            `;
    const popupRestrictNTHtml = `
                <div class="popup popup-validate-restrict" data-popup="popup-3">
                    <div class="popup-inner">
                        <h2 class="bss-purchase-late-restrict-note">Restrict Net Terms options according to Order Amount/Quantity</h2>
                        <div class="popup-scroll">
                            <span><p class="valid-netterm-product"></p></span>
                            <span class="valid-netterm-product-message"><p></p></span>
                        </div>
                        <a class="popup-close popup-validate-restrict" data-popup-close="popup-3" href="#">x</a>
                    </div>
                </div>
            `;
    const popupCustomerLogin = `
                <div class="popup popup-customer-login" data-popup="popup-3">
                    <div class="popup-inner">
                        <h2 class="bss-purchase-late-note">Purchase Late Note</h2>
                        <div class="popup-scroll">
                            <span class="invalid-netterm-rule-message-login">Please login or register account to purchase late these items</span>
                        </div>
                        <p><a class="bss-proceed-to-purchase-late-login" href="/account/login">Proceed to account login/register page</a></p>
                        <a class="popup-close popup-customer-login" data-popup-close="popup-3" href="#">x</a>
                    </div>
                </div>
            `;
    // Define style popup
    window.document.body.insertAdjacentHTML('afterbegin', popupHtml);
    window.document.body.insertAdjacentHTML('afterbegin', popupMultiButton);
    window.document.body.insertAdjacentHTML('afterbegin', popupRestrictNTHtml);
    window.document.body.insertAdjacentHTML('afterbegin', popupCustomerLogin);

    // content modal
    document.querySelectorAll('.bss-purchase-late-note').forEach(item => item.innerHTML = bssPurchaseLateTranslation["purchase_late_note"]);
    document.querySelector('.invalid-netterm-product-message').innerHTML = bssPurchaseLateTranslation["purchase_late_message"];
    document.querySelector('.invalid-netterm-rule-message').innerHTML = bssPurchaseLateTranslation["purchase_late_message_qualify"];
    document.querySelector('.bss-proceed-to-purchase-late').innerHTML = bssPurchaseLateTranslation["purchase_late_link"];
    document.querySelector('.invalid-netterm-rule-message-login').innerHTML = bssPurchaseLateTranslation["purchase_late_message_login"];
    document.querySelector('.bss-proceed-to-purchase-late-login').innerHTML = bssPurchaseLateTranslation["purchase_late_link_login"];

    // Custom
    customTextModal(bssPurchaseLateTranslation);
}

/**
 * Create button checkout on mini cart
 * @param textBtn
 * @param id
 * @param tagElement
 * @param className
 * @param isMultipleBtn
 * @param btnViewCart
 * @param rule
 * @returns {void}
 */
const createMiniNTCheckoutBtn = (BSS_BCP, btnText, id, tagName, className, multipleBtn, btnViewCart, rule = false) => {
    let miniNtCheckoutBtn = null;
    const btnTextMiniCart = document.createTextNode(btnText);
    miniNtCheckoutBtn = document.createElement(tagName);
    defineNtBtn(miniNtCheckoutBtn, className, id, btnText, btnTextMiniCart);

    if (BSS_BCP.configData.nt_replace_checkout) {
        btnViewCart.style.display = 'none';
    }
    btnViewCart.after(miniNtCheckoutBtn);
    handleEventFromB2B(miniNtCheckoutBtn, rule, multipleBtn);

    // Custom for store id ....
}
// CONCATENATED MODULE: ./src/js/src/nt/index.js





function initNT(shopData, BSS_BCP) {
    // Define variable global
    let ruleNtApply = {};
    let invalidRuleNtApply = {};
    let checkoutBtn = null;
    let checkoutBtnQuery = "";
    const ntApply = BSS_BCP.nt.config.nt_apply_to;
    const customer = shopData.customer;
    const bssPurchaseLateTranslation = {};
    const isShowBtn = showPurchaseLateBtn(BSS_BCP, customer, ntApply);

    BSS_BCP.nt.translation && BSS_BCP.nt.translation.map(item => {
        bssPurchaseLateTranslation[item.key] = item.value;
    })

    /**
     * @description Define popup
     */
    definePopup(bssPurchaseLateTranslation);

    /**
     * @description Get cart
     * @param isFirstLoad
     * @returns {Promise}
     */
    BSS_BCP.netterm.getCartData = async function (isFirstLoad) {
        const _cart = await BSS_BCP.helper.getCart();
        if (_cart) {
            BSS_BCP.netterm.validatePurchaseLate(_cart, isFirstLoad);
        }
    }

    /**
     * @description Show button on cart page
     * @returns {void}
     */
    BSS_BCP.netterm.showButtonOnCartPage = function () {
        // Define selector button checkout
        if (BSS_BCP.nt.config.nt_replace_checkout || BSS_BCP.nt.config.nt_display_position === 0) {
            checkoutBtnQuery = BSS_BCP.helper.CheckoutBtnDefaultQuery;
        } else if (BSS_BCP.nt.config.nt_display_position === 1) {
            checkoutBtnQuery = BSS_BCP.helper.checkoutBtnCartPage;
        } else if (BSS_BCP.nt.config.nt_display_position === 2) {
            checkoutBtnQuery = BSS_BCP.helper.checkoutBtnMiniCart;
        }
        checkoutBtn = document.querySelectorAll(checkoutBtnQuery);

        // custom selector button checkout for store
        customButtonCheckout(BSS_BCP, checkoutBtn);

        if (isShowBtn) {
            if (ntApply === 2) {
                for (let i = BSS_BCP.nt.rules.length - 1; i >= 0; i--) {
                    let rule = BSS_BCP.nt.rules[i];
                    if (checkoutBtn.length) {
                        let checkoutNtBtn = null;
                        let btnText = document.createTextNode(rule.name);
                        checkoutNtBtn = document.createElement(checkoutBtn[0].tagName)
                        checkoutNtBtn.setAttribute('apply_to', rule.apply_to);
                        checkoutNtBtn.setAttribute('product_condition_type', rule.product_condition_type);
                        defineNtBtn(checkoutNtBtn, checkoutBtn[0].className, 'bss-nt-purchase-late-' + rule.id, rule.name, btnText);


                        if ((typeof (BSS_B2B) != 'undefined') && BSS_B2B) {
                            handleEventFromB2B(checkoutNtBtn, rule, true);
                        } else {
                            checkoutNtBtn.onclick = function () {
                                const id = this.id.toString().replace("bss-nt-purchase-late-", "");
                                handleClickPurchaseLate(id, rule, true);
                            }
                        }

                        for (let i = 0; i < checkoutBtn.length; i++) {
                            if (BSS_BCP.nt.config.nt_replace_checkout) {
                                checkoutBtn[i].style.display = 'none';
                            }
                            checkoutBtn[i].after(checkoutNtBtn);

                            if (checkoutBtn[i].parentElement.className === 'cart__ctas' && BSS_BCP.nt.rules.length >= 3) {
                                checkoutBtn[i].parentElement.style.flexDirection = 'column'
                            }
                        }
                    }
                }
            } else {
                if (checkoutBtn.length) {
                    let checkoutNtBtn = null;
                    let btnText = document.createTextNode(bssPurchaseLateTranslation["purchase_late"]);
                    checkoutNtBtn = document.createElement(checkoutBtn[0].tagName);
                    defineNtBtn(checkoutNtBtn, checkoutBtn[0].className, checkoutBtn[0].id, bssPurchaseLateTranslation["purchase_late"], btnText);

                    if ((typeof (BSS_B2B) != 'undefined') && BSS_B2B) {
                        handleEventFromB2B(checkoutNtBtn, {});
                    } else {
                        checkoutNtBtn.onclick = function () {
                            const id = this.id.toString().replace("bss-nt-purchase-late-", "");
                            handleClickPurchaseLate(id);
                        }
                    }

                    for (let i = 0; i < checkoutBtn.length; i++) {
                        if (!(checkoutBtn[i].classList.contains('bss-b2b-customer-portal-nt-checkout-btn'))) {
                            if (BSS_BCP.nt.config.nt_replace_checkout) {
                                customDisplayBtn(checkoutBtn[i]);
                                let checkExistNtBtn = false;
                                let checkoutBtnList = null;
                                let checkoutBtnParent = checkoutBtn[i].closest('form[action*="/cart"]');
                                if (checkoutBtnParent) {
                                    checkoutBtnList = checkoutBtnParent.querySelectorAll(checkoutBtnQuery);
                                }
                                if (checkoutBtnList && checkoutBtnList.length) {
                                    for (let j = 0; j < checkoutBtnList.length; j++) {
                                        if (checkoutBtnList[j].classList.contains('bss-b2b-customer-portal-nt-checkout-btn')) {
                                            checkExistNtBtn = true;
                                        }
                                    }
                                }

                                customCheckExistBtn(checkExistNtBtn);
                                customCheckoutNT(BSS_BCP);

                                if (!checkExistNtBtn) {
                                    btnText = document.createTextNode(bssPurchaseLateTranslation["purchase_late"]);
                                    checkoutNtBtn = document.createElement(checkoutBtn[i].tagName);
                                    defineNtBtn(checkoutNtBtn, checkoutBtn[i].className, checkoutBtn[i].id, bssPurchaseLateTranslation["purchase_late"], btnText);
                                    customPositionNTBtn(checkoutBtn, checkoutNtBtn, i);

                                    checkoutBtn[i].style.display = 'none';
                                    checkoutNtBtn.onclick = function () {
                                        const id = this.id.toString().replace("bss-nt-purchase-late-", "");
                                        handleClickPurchaseLate(id);
                                    }
                                }
                            }
                            
                            if (BSS_BCP.storeId === 2469 && i>0) {
                                let checkoutNtBtnNew = null;
                                let btnText = document.createTextNode(bssPurchaseLateTranslation["purchase_late"]);
                                checkoutNtBtnNew = document.createElement(checkoutBtn[i].tagName);
                                defineNtBtn(checkoutNtBtnNew, checkoutBtn[i].className, checkoutBtn[i].id, bssPurchaseLateTranslation["purchase_late"], btnText);
                                if ((typeof (BSS_B2B) != 'undefined') && BSS_B2B) {
                                    handleEventFromB2B(checkoutNtBtnNew, {});
                                } else {
                                    checkoutNtBtnNew.onclick = function () {
                                        const id = this.id.toString().replace("bss-nt-purchase-late-", "");
                                        handleClickPurchaseLate(id);
                                    }
                                };
                                checkoutBtn[i].after(checkoutNtBtnNew);
                            } else {
                                checkoutBtn[i].after(checkoutNtBtn);
                            }
                            if(BSS_BCP.storeId === 2973) {
                                break;
                            }
                        }
                    }
                }
            }
        }
    }

    /**
     * @description Handle validate product after purchase late
     * @returns {Promise}
     */
    BSS_BCP.netterm.validateProductBeforePurchaseLate = function () {
        if (ntApply === 2) {
            const { isApplyRule, rule } = checkRuleNtApply(customer, ruleNtApply);
            if (isApplyRule) {
                return BSS_BCP.netterm.getCartData(false);
            } else {
                if (rule && rule.id) {
                    const elementRuleNT = document.querySelector('.bss-purchase-late-rule-name');
                    if (elementRuleNT) {
                        elementRuleNT.innerHTML = rule.name;
                    }
                    if (rule.apply_to === 3) {
                        showPopup('popup-customer-login');
                    } else {
                        showPopup('popup-multi-button');
                    }
                }
            }
        } else if (ntApply === 1) {
            const _customer = { id: customer.id, tags: customer.tags };
            const ruleCheck = Object.keys(ruleNtApply).length ? ruleNtApply : invalidRuleNtApply;
            const customerApply = checkCustomer(ruleCheck, _customer);
            if (customerApply) {
                return BSS_BCP.netterm.getCartData(false);
            } else {
                ruleNtApply = Object.keys(ruleNtApply).length ? ruleNtApply : invalidRuleNtApply;
                if (ruleNtApply.apply_to === 3) {
                    showPopup('popup-customer-login');
                } else {
                    showPopup('popup-multi-button');
                }
            }
        } else {
            return BSS_BCP.netterm.getCartData(false);
        }
    }

    /**
     * @description Handle validate purchase late
     * @returns {void}
     */
    BSS_BCP.netterm.validatePurchaseLate = function (cartData, isFirstLoad = true) {
        try {
            if (cartData && cartData.items && cartData.items.length > 0) {
                let handleUrls = [], handles = [], keyIdMap = new Map(), itemsData = [];

                cartData.items.forEach(function (item) {
                    itemsData.push({
                        id: item.product_id,
                        final_line_price: item.final_line_price,
                        quantity: item.quantity,
                        title: item.title
                    });
                    let proId = item.product_id;
                    if (handles.indexOf(proId) === -1) {
                        handles.push(proId);
                        handleUrls.push('id:"' + proId + '"');
                        keyIdMap.set(proId, []);
                    }
                    let productItemKeys = keyIdMap.get(proId);
                    productItemKeys.push(item.key)
                    keyIdMap.set(proId, productItemKeys);
                })

                const urlData = '/search.js?q=' + handleUrls.join(' OR ') + '&view=bss.bcp';
                const encodeUrlData = encodeURI(urlData);
                const getSearchDataReq = fetch(encodeUrlData, {
                    method: 'GET'
                });
                getSearchDataReq
                    .then(function (response) {
                        if (!response.ok) {
                            throw new Error("HTTP error, status = " + response.status);
                        }
                        const dataJSON_promise = response.json();
                        return dataJSON_promise;
                    })
                    .then(async function (responProd) {
                        // Custom for product has metafield
                        if (responProd.length < cartData.items.length && [2327].includes(BSS_BCP.storeId)) {
                            const cartData = document.querySelector('.bss-b2b-cart-metafield');
                            if (cartData && cartData.innerText) {
                                responProd = JSON.parse(cartData.innerText).cartItem;
                            }
                        }
                        if (responProd.length > 0) {
                            let productMap = [];
                            let checkUnique = [];
                            for (let i = 0; i < responProd.length; i++) {
                                let pro = responProd[i];
                                if (checkUnique.indexOf(pro.id) === -1) {
                                    checkUnique.push(pro.id);
                                    keyIdMap.get(pro.id).forEach(function (key) {
                                        productMap.push({
                                            key: key,
                                            product_id: pro.id,
                                            title: pro.title,
                                            tags: pro.tags,
                                            collections: pro.collections
                                        });
                                    })
                                }
                            }
                            checkUnique = [];

                            const { _ruleNtApply, _invalidRuleNtApply } = checkRuleForCustomerAndProduct(BSS_BCP, productMap, ntApply, customer);
                            ruleNtApply = _ruleNtApply, invalidRuleNtApply = _invalidRuleNtApply;

                            // Check valid-invalid product
                            let invalidNtProductNtRule = [];
                            let validNtProductNtRule = [];
                            productMap.map((item) => {
                                let isValidProduct = checkProductPurchaseLate(item, ruleNtApply, invalidRuleNtApply);
                                if (!isValidProduct) {
                                    invalidNtProductNtRule.push(item);
                                    checkUnique.push(item.product_id);
                                }
                            })
                            itemsData.map((item) => {
                                if (!checkUnique.includes(item.id)) {
                                    validNtProductNtRule.push(item);
                                }
                            });

                            if (!isFirstLoad) {
                                const bssBCPNTChoose = Object.keys(invalidRuleNtApply).length > 0 ? invalidRuleNtApply : ruleNtApply;
                                localStorage.setItem('bssBCPNtId', bssBCPNTChoose.id);
                                const hasQIError = document.getElementsByClassName('modalWarningQI').length && document.getElementsByClassName('modalWarningQI')[0].style.display == "block";
                                if (hasQIError || document.querySelector('.bss-modal-amo.active')) {
                                    // do nothing, block store go direct to bcp proxy 
                                    // do nothing, OL warning popup show
                                } else if (bssBCPNTChoose.apply_to == 3 && invalidNtProductNtRule.length) {
                                    if (customer.id) {
                                        handleShowPopup(BSS_BCP, invalidNtProductNtRule, validNtProductNtRule, ntApply, ruleNtApply, invalidRuleNtApply);
                                    } else {
                                        showPopup('popup-customer-login');
                                    }
                                } else if ((bssBCPNTChoose.product_condition_type != 0 && invalidNtProductNtRule.length) || (!ruleNtApply && invalidNtProductNtRule.length)) {
                                    handleShowPopup(BSS_BCP, invalidNtProductNtRule, validNtProductNtRule, ntApply, ruleNtApply, invalidRuleNtApply);
                                } else if (validNtProductNtRule.length) {
                                    await handleRemoveProduct(invalidNtProductNtRule, validNtProductNtRule, ntApply, ruleNtApply, invalidRuleNtApply);
                                } else {
                                    window.location = '/apps/customer-portal/purchase-late';
                                }
                            }
                        }
                    })
                    .catch(function (error) {
                        // eslint-disable-next-line no-console
                        console.log("No! Something error:", error);
                    });
            } else {
                const { _ruleNtApply, _invalidRuleNtApply } = checkRuleForCustomerAndProduct(BSS_BCP, [], ntApply, customer);
                ruleNtApply = _ruleNtApply, invalidRuleNtApply = _invalidRuleNtApply;
                // eslint-disable-next-line no-console
                console.log("Cart data is empty");
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log("Could not get shop data");
        }
    }

    /**
     * @description Handle button mini cart
     * @param event
     * @param timeDelay
     * @returns {void}
     */
    BSS_BCP.netterm.handleButtonMiniCart = (event, delaySetInterval) => {
        let handleCreateCheckoutBtn = setInterval(function () {
            let miniCartBtn = null;
            if (event === "click") {
                miniCartBtn = document.querySelectorAll(BSS_BCP.helper.miniCartBtn);
            } else if (event === "mouseover") {
                miniCartBtn = document.querySelectorAll(BSS_BCP.helper.btnViewCart);
            }

            if (miniCartBtn && miniCartBtn.length) {
                for (let y = 0; y < miniCartBtn.length; y++) {
                    let miniCartBtnParentClass = miniCartBtn[y].parentElement.className.split(' ').join('.');
                    let viewCartBtnParent = document.querySelectorAll(miniCartBtnParentClass
                        ? '.' + miniCartBtnParentClass + ' .bss-b2b-customer-portal-nt-checkout-btn'
                        : '.bss-b2b-customer-portal-nt-checkout-btn'
                    );
                    if (!viewCartBtnParent.length) {
                        if (ntApply === 2) {
                            for (let i = BSS_BCP.nt.rules.length - 1; i >= 0; i--) {
                                let rule = BSS_BCP.nt.rules[i];
                                createMiniNTCheckoutBtn(BSS_BCP, rule.name, 'bss-nt-purchase-late-' + rule.id, miniCartBtn[0].tagName, miniCartBtn[0].className, true, miniCartBtn[y], rule);
                            }
                        } else {
                            createMiniNTCheckoutBtn(BSS_BCP, bssPurchaseLateTranslation["purchase_late"], miniCartBtn[0].id, miniCartBtn[0].tagName, miniCartBtn[0].className, false, miniCartBtn[y]);
                        }
                    }
                }

                clearInterval(handleCreateCheckoutBtn);
            }
        }, delaySetInterval);

        setTimeout(function () {
            clearInterval(handleCreateCheckoutBtn);
        }, 2000);
    }

    // Show button purchase late on mini cart
    const handleFirstLoad = function () {
        if (isShowBtn && [0, 2].includes(BSS_BCP.nt.config.nt_display_position)) {
            let delaySetInterval = 500;
            const ajaxCartElement = document.querySelectorAll(BSS_BCP.helper.ajaxCartElement);
            const mouseOverAjaxCart = document.querySelectorAll(BSS_BCP.helper.mouseOverAjaxCart);

            // Custom query ajax cart, delay
            for (let i = 0; i < ajaxCartElement.length; i++) {
                ajaxCartElement[i].onclick = function () {
                    BSS_BCP.netterm.handleButtonMiniCart("click", delaySetInterval);
                }
            }

            for (let i = 0; i < mouseOverAjaxCart.length; i++) {
                mouseOverAjaxCart[i].onmouseover = function () {
                    BSS_BCP.netterm.handleButtonMiniCart("mouseover", delaySetInterval);
                }
            }
        }


        // Handle add to cart => check new rule apply
        const buttonAddToCart = document.querySelectorAll('form[action="/cart/add"] button[type="submit"]');
        if (buttonAddToCart && buttonAddToCart.length) {
            buttonAddToCart.forEach(item => {
                item.onclick = function () {
                    setTimeout(() => {
                        BSS_BCP.netterm.getCartData(true);
                    }, 1000);
                }
            })
        }
    }


    // First load
    handleFirstLoad();
    BSS_BCP.netterm.getCartData(true);

    // Handle custom and show button NT on cart page
    customBcpNetterm(BSS_BCP);
}
// CONCATENATED MODULE: ./src/js/src/vo/checkEntity.js
/**
 * Check customer
 * @param customer
 * @returns {void}
 */
const checkCustomerForVO = (BSS_BCP, customer) => {
    let ruleApplyCustomers = [];
    for (let i = 0; i < BSS_BCP.vo.rules.length; i++) {
        let ruleCheck = BSS_BCP.vo.rules[i];
        if (ruleCheck.customer_condition_type == 0) {
            ruleApplyCustomers.push(ruleCheck);
        }
        if (ruleCheck.customer_condition_type == 1) {
            if (customer.id) {
                ruleApplyCustomers.push(ruleCheck);
            }
        }
        if (ruleCheck.customer_condition_type == 2) {
            if (ruleCheck.customer_ids.length && customer.id) {
                if (ruleCheck.customer_ids.includes(customer.id.toString())) {
                    ruleApplyCustomers.push(ruleCheck);
                }
            }
        }
        if (ruleCheck.customer_condition_type == 3) {
            if (ruleCheck.customer_tags.length && customer.tags && customer.tags.length) {
                let result = customer.tags.filter(tag => ruleCheck.customer_tags.includes(tag))
                if (result.length) {
                    ruleApplyCustomers.push(ruleCheck);
                }
            }
        }
    }
    return ruleApplyCustomers;
}

/**
 * Check product
 * @param rules
 * @returns {void}
 */
const checkProductForVO = (ruleApplyCustomers, productId, productCollections, productTags) => {
    let ruleApply = [];
    for (let i = 0; i < ruleApplyCustomers.length; i++) {
        const ruleCheck = ruleApplyCustomers[i];
        const productType = ruleCheck.product_condition_type;
        if (productType === 0) {
            ruleApply.push(ruleCheck);
        }
        if (productType === 1) {
            if (ruleCheck.product_ids.length) {
                if (ruleCheck.product_ids.indexOf((productId + "")) !== -1) {
                    ruleApply.push(ruleCheck);
                }
            }
        }
        if (productType === 2) {
            if (productCollections.length && ruleCheck.product_collections.length) {
                const result = productCollections.filter(item => ruleCheck.product_collections.includes(item + ""));

                if (result.length) {
                    ruleApply.push(ruleCheck);
                }
            }
        }
        if (productType === 3) {
            if (productTags.length && ruleCheck.product_tags.length) {
                const result = productTags.filter(element => ruleCheck.product_tags.includes(element));
                if (result.length) {
                    ruleApply.push(ruleCheck);
                }
            }
        }
    }
    return ruleApply;
}
// CONCATENATED MODULE: ./src/js/src/vo/custom/main.js
const customRow2 = (BSS_BCP, rowTitle, variant) => {
    // Check shopify.shop - store id: suggest store id
    if ([1792].includes(BSS_BCP.storeId)) {
        let variantSku = document.createElement('p');
        variantSku.style.margin = 'unset';
        variantSku.style.marginTop = '10px';
        variantSku.innerHTML = `SKU:${variant.sku}`;
        rowTitle.appendChild(variantSku);
    }
}

const customInStock = (BSS_BCP, inStock, translations) => {
    if ([1792].includes(BSS_BCP.storeId)) {
        inStock.innerHTML = `${translations["vo_inStock"]}`;
    }
}

const customAfterAddCart = (BSS_BCP) => {
    if ([611].includes(BSS_BCP.storeId)) {
        const addedToCart = document.querySelector('.bss-b2b-variants-order [x-show="addedToCart"]');
        if (addedToCart) {
            addedToCart.style.display = "block";
        }
    }
}

const customAfterAppendBuyItNow = (BSS_BCP) => {
    if ([611].includes(BSS_BCP.storeId)) {
        const productContainer = document.querySelector('.shopify-section .product-content-container .product-block-area');
        if (productContainer) {
            const productVariantsBlock = productContainer.querySelector('form[action="/cart/add"]');
            if (productVariantsBlock) {
                productVariantsBlock.remove();
            }
        }
    }
}

const customRemoveElement = (BSS_BCP) => {
    if ([611].includes(BSS_BCP.storeId)) {
        let toRemoveElems = [];
        let productContainer = document.querySelector('.shopify-section .product-content-container .product-block-area');
        if (productContainer) {
            let productVariantsBlock = productContainer.querySelector('.product-variant-picker-block');
            if (productVariantsBlock) toRemoveElems.push(productVariantsBlock);
            let productQuantityBlock = productContainer.querySelector('.product-quantity-block');
            if (productQuantityBlock) toRemoveElems.push(productQuantityBlock);
        }
        for (let i = 0; i < toRemoveElems.length; i++) {
            toRemoveElems[i].remove();
        }
    }
}

const generateElementCpPrice = (rowPriceParent, rowPrice, row_dataCompare, variant, isComparePrice, BSS_B2B, BSS_BCP) => {
    const priceInner = isComparePrice ? variant.compare_at_price : variant.price;
    rowPriceParent.appendChild(row_dataCompare);
    row_dataCompare.after(rowPrice)
    row_dataCompare.innerHTML = `<span>${BSS_BCP.formatMoney(priceInner)}</span>`
    row_dataCompare.style.color = `${BSS_B2B.cpSettings.default_price_color}`;
    row_dataCompare.style.textDecoration = "line-through";
}

const handleStyleElementForVo = (ele) => {
    if (ele && ele.length) {
        for (let i = 0; i < ele.length; i++) {
            ele[i].style.display = 'none';
        }
    }
}
// CONCATENATED MODULE: ./src/js/src/vo/action.js

/**
 * Handle enforce input
 * @param input
 * @param maxQuantity
 * @param policy
 * @param track
 * @returns {void}
 */
const enforceMinMax = (e, max, policy, track) => {
    const value = e.target.value;
    if (value != "") {
        if (parseInt(value) < 0) {
            e.target.value = 0;
        }
        if (parseInt(value) > parseInt(max)) {
            if (policy != 'continue' && track) {
                e.target.value = max;
            }
        }
    }
}

/**
 * Handle input increment
 * @param input
 * @param maxQuantity
 * @param policy
 * @param track
 * @returns {void}
 */
const incrementQuantity = (input, max, policy, track) => {
    const newValue = Number(input.value) + 1;
    if (policy != 'continue' && track) {
        newValue > max ? input.value = max : input.value = newValue;
    } else {
        input.value = newValue;
    }
}

/**
 * Handle input decrement
 * @param input
 * @returns {void}
 */
const decrementQuantity = (input) => {
    const newValue = Number(input.value) - 1;
    newValue < 0 ? input.value = 0 : input.value = newValue;
}
// CONCATENATED MODULE: ./src/js/src/vo/render.js



/**
 * Create button add to cart
 * @param messageErrorEle
 * @returns {HTMLButtonElement}
 */
const createAddToCartBtn = (BSS_BCP, msgError, addToCartVoDefault, translations) => {
    const btnAddToCart = document.createElement('button');
    const btnAddToCartText = document.createTextNode(translations["vo_addToCart"]);
    btnAddToCart.className = "bss_add_to_cart_vo";

    if (addToCartVoDefault.length) {
        btnAddToCart.className = addToCartVoDefault[0].className + " bss-b2b-customer-portal-variants-order-btn";
        btnAddToCart.id = addToCartVoDefault[0].id;
    }

    btnAddToCart.appendChild(btnAddToCartText);
    btnAddToCart.addEventListener('click', async function () {
        let listBuy = [...document.querySelectorAll(".bss-b2b-variants-order-table .number-input input")];
        listBuy = listBuy.map(item => ({ id: +item.id, quantity: +item.value })).filter(item => item.quantity > 0);

        try {
            if (listBuy.length) {
                btnAddToCart.disabled = true;
                const newCartReq = await fetch('/cart/add.js', {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ items: listBuy })
                });
                if (!newCartReq.ok) {
                    const text = await newCartReq.text();
                    const msg = JSON.parse(text);
                    if (msg.description) {
                        msgError.innerHTML = '*' + msg.description;
                    }
                    btnAddToCart.disabled = false;
                    throw new Error(text);
                }
                const newCartData = await newCartReq.json();

                if (newCartData && newCartData.items.length) {
                    if ([611].includes(BSS_BCP.storeId)) {
                        customAfterAddCart(BSS_BCP);
                    } else {
                        window.location.href = '/cart';
                    }
                }
            } else {
                msgError.innerHTML = '* ' + translations["vo_atLeast1Item"];
                btnAddToCart.disabled = false;
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log('BSSVOCreateAddToCartBtn error:', error);
        }
    });

    return btnAddToCart;
}

/**
 * Create button buy it now
 * @param messageErrorEle
 * @param buttonCheckoutEle
 * @returns {HTMLButtonElement}
 */
const createBuyItNowBtn = (msgError, BSSVOCheckoutDefault, translations) => {
    const btnBuyItNowText = document.createTextNode(translations["vo_buyItNow"]);
    const btnBuyItNow = BSSVOCheckoutDefault[0].cloneNode(true);
    btnBuyItNow.id = "bss-bcp-vo-buy-it-now";
    btnBuyItNow.style.display = 'block';
    btnBuyItNow.before(btnBuyItNowText);

    let btnAddEvent = btnBuyItNow;
    let shopDataB2B = false;
    const checkCP = (typeof BSS_B2B !== "undefined") && BSS_B2B.cpRuleChoice && BSS_B2B.cpRuleChoice.length;
    if (checkCP) {
        shopDataB2B = JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML);
        // const checkoutButton = document.querySelector(BSS_BCP.helper.buyItNowBtnForVO);
        // checkoutButton.style.height = '40px';
        // btnAddEvent = checkoutButton;
        BSS_B2B.handleCartCheckoutBtn(shopDataB2B);
    }

    btnAddEvent.addEventListener('click', async function (e) {
        let listBuy = [...document.querySelectorAll(".bss-b2b-variants-order-table .number-input input")];
        listBuy = listBuy.map(item => ({ id: +item.id, quantity: +item.value })).filter(item => item.quantity > 0);
        if (shopDataB2B && checkCP) {
            shopDataB2B = {
                ...shopDataB2B,
                cart: {
                    ...shopDataB2B.cart,
                    items: listBuy
                }
            }
        }

        try {
            if (listBuy.length) {
                btnBuyItNow.disabled = true;
                const clearCart = await fetch('/cart/clear.js', { method: "POST", headers: { 'Content-Type': 'application/json' } });
                if (!clearCart.ok) {
                    const text = await clearCart.text();
                    const msg = JSON.parse(text);
                    if (msg.description) {
                        msgError.innerHTML = '*' + msg.description;
                    }
                    btnBuyItNow.disabled = false;
                    throw new Error(text);
                }

                const newCartReq = await fetch('/cart/add.js', {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ items: listBuy })
                });
                if (!newCartReq.ok) {
                    const text = await newCartReq.text();
                    const msg = JSON.parse(text);
                    if (msg.description) {
                        msgError.innerHTML = '*' + msg.description;
                    }
                    btnBuyItNow.disabled = false;
                    throw new Error(text);
                }
                const newCartData = await newCartReq.json();
                if (newCartData && newCartData.items.length) {
                    if (checkCP) {
                        $(this).off();
                        e.stopImmediatePropagation();
                        e.preventDefault();
                        e.stopPropagation();

                        if ((typeof BSS_B2B !== "undefined") && BSS_B2B) {
                            const invalidIncrementProduct = BSS_B2B.qi.invalidIncrementProducts;
                            if (invalidIncrementProduct) {
                                BSS_B2B.qi.renderWarningMessage(invalidIncrementProduct);
                                return;
                            }

                            BSS_B2B.modifyCartDataAndCreateCheckout(shopDataB2B, "", this, this, false, false, [], false, false);
                        }
                    } else {
                        window.location.href = '/checkout';
                    }
                } else {
                    // do ...
                }
            } else {
                msgError.innerHTML = '* ' + translations["vo_atLeast1Item"];
                btnBuyItNow.disabled = false;
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log('BSSVOCreateBuyItNowBtn error:', error);
        }
    });

    return btnBuyItNow;
}

/**
 * Create button buy it now
 * @returns {HTMLTableElement}
 */
const createTable = (productVariants, productId, shopData, translations) => {
    const moneyCode = shopData.money_code;
    const moneyFormat = shopData.money_format;
    const variantsQuantity = shopData.variants_quantity;
    const variantsPolicy = shopData.variants_policy;

    let table = document.createElement('table');
    let thead = document.createElement('thead');
    let tbody = document.createElement('tbody');

    table.appendChild(thead);
    table.appendChild(tbody);
    table.className = "bss-b2b-variants-order-table";

    productVariants.map(variant => {
        let row = document.createElement('tr');
        let itemVariant = document.createElement('div');
        let row_image = document.createElement('div');
        let aTag = document.createElement('p');

        itemVariant.className = 'bss-vo-item-variant';
        row.style.borderTop = row.style.borderBottom = '2px solid #ebeef0';
        row_image.style.width = '100px';

        tbody.appendChild(row);
        row.appendChild(itemVariant);

        // Row image
        if (variant.featured_image) {
            let imageV = document.createElement('img');
            let modal = document.createElement('div');
            let modalContent = document.createElement('div');
            let closeBtn = document.createElement('span');

            imageV.src = variant.featured_image.src;
            imageV.className = "bss-b2b-image-child";
            modal.className = "bss-b2b-modal-image";
            modalContent.className = "bss-b2b-modal-image-content";
            closeBtn.className = "bss-b2b-close-modal-image";
            closeBtn.innerHTML = "&times;";

            modal.appendChild(modalContent);
            modalContent.appendChild(closeBtn);
            modalContent.appendChild(imageV);
            aTag.appendChild(modal);
            aTag.appendChild(imageV.cloneNode(true));

            window.addEventListener('click', function (event) {
                if (event.target == modal || event.target == closeBtn) {
                    modal.style.display = "none";
                }
            })
            aTag.addEventListener('click', function () {
                modal.style.display = "block";
            })
        } else {
            // Do nothing or apply image default
        }

        row_image.appendChild(aTag);
        itemVariant.appendChild(row_image);

        // Row title
        let rowTitle = document.createElement('div');
        let variantTitle = document.createElement('p');

        rowTitle.style.width = '150px';
        variantTitle.style.margin = 'unset';
        variantTitle.innerHTML = variant.public_title;

        rowTitle.appendChild(variantTitle);

        // Custom for store 
        if ([1792].includes(BSS_BCP.storeId)) {
            customRow2(BSS_BCP, rowTitle, variant);
        }

        itemVariant.appendChild(rowTitle);

        // Row price
        let rowPrice = document.createElement('div');
        let rowPriceParent = document.createElement('div');
        if (BSS_BCP.isEnableQuote && BSS_BCP.quoteSettings && Object.keys(BSS_BCP.quoteSettings).length > 0 && BSS_BCP.quoteSettings.hide_price === 1) {
            rowPriceParent.style.display = "none";
        } else {
            rowPriceParent.className = 'bss-b2b-price-parent-element';
            rowPrice.className = 'bss-b2b-price-element';
        }


        // create Compare price element 
        let row_dataCompare = document.createElement('div');
        row_dataCompare.className = 'bss-b2b-compare-price';
        let variantsPrice = variant.price / 100;

        document.addEventListener("bss_b2b_doneCheckCp", () => {
            if (typeof BSS_B2B != "undefined" && BSS_B2B.cpRuleChoice && BSS_B2B.cpRuleChoice.length) {
                // let shopData = JSON.parse(document.querySelector('#bss-b2b-store-data').innerHTML);
                // shopData.product.collections = shopData.collections
                // let setCount = 0;
                // let interval = setInterval(() => {
                //     if (setCount === 5 || (BSS_B2B.cpRuleChoice && BSS_B2B.cpRuleChoice.length)) {
                //         clearInterval(interval)
                //     }
                //     setCount += 1
                // }, 2000)

                const appliedCPRule = BSS_B2B.cpRuleChoice.find(item => item.id === productId);
                if (appliedCPRule) {
                    const cpRule = { type: appliedCPRule.discount_type, value: +appliedCPRule.value };
                    if (cpRule.type == 0) {
                        if (variantsPrice > cpRule.value) {
                            variantsPrice = cpRule.value;
                        }
                    } else if (cpRule.type == 1) {
                        if (variantsPrice < cpRule.value) {
                            variantsPrice = 0;
                        } else {
                            variantsPrice = (variant.price / 100) - cpRule.value;
                        }
                    } else {
                        variantsPrice = (variant.price / 100) - (((variant.price / 100) * cpRule.value) / 100);
                    }
                }
            }
        })

        const voMultiCur = document.querySelectorAll('.bss-nice-select li.option');
        if (voMultiCur.length && (typeof BSS_B2B != "undefined") && BSS_B2B.currencyConfig) {
            // setTimeout(() => {
            const currentCurrencyCode = document.querySelector('.current-currency').innerHTML;
            if (currentCurrencyCode) {
                let comparePrice = variant.compare_at_price ? parseFloat(window.Currency.convert(variant.compare_at_price / 100, moneyCode, currentCurrencyCode)).toFixed(2) : 0;
                let price = parseFloat(window.Currency.convert(variantsPrice, moneyCode, currentCurrencyCode)).toFixed(2)
                rowPrice.innerHTML = `${(variant.compare_at_price && (variant.compare_at_price / 100) > variantsPrice) ? `<del>${comparePrice}  ${currentCurrencyCode}</del><br><true>${price}  ${currentCurrencyCode}</true>` : `${price}  ${currentCurrencyCode}`}`;
            } else {
                rowPrice.innerHTML = `${(variant.compare_at_price && (variant.compare_at_price / 100) > variantsPrice) ? `<del>${variant.compare_at_price / 100}  ${moneyFormat}</del><br><true>${variantsPrice}  ${moneyFormat}</true>` : `${variantsPrice}  ${moneyFormat}`}`;
            }
            // }, 2000)


            for (let i = 0; i < voMultiCur.length; i++) {
                voMultiCur[i].addEventListener('click', () => {
                    // setTimeout(() => {
                    let comparePrice = variant.compare_at_price ? parseFloat(window.Currency.convert(variant.compare_at_price / 100, moneyCode, currentCurrencyCode)).toFixed(2) : 0;
                    let price = parseFloat(window.Currency.convert(variantsPrice, moneyCode, currentCurrencyCode)).toFixed(2)
                    rowPrice.innerHTML = `${(variant.compare_at_price && (variant.compare_at_price / 100) > variantsPrice) ? `<del>${comparePrice}  ${currentCurrencyCode}</del><br><true>${price}  ${currentCurrencyCode}</true>` : `${price} ${currentCurrencyCode}`}`;
                    // }, 200)
                });
            }
        } else {
            if (typeof BSS_B2B === "undefined") {
                rowPrice.innerHTML = `${(variant.compare_at_price && (variant.compare_at_price / 100) > variantsPrice) ? `<del>${BSS_BCP.formatMoney(variant.compare_at_price)}</del><br><true>${BSS_BCP.formatMoney(variantsPrice * 100)}</true>` : `${BSS_BCP.formatMoney(variantsPrice * 100)}`}`;
            } else {
                let doneCheckCp = false;
                document.addEventListener("bss_b2b_doneCheckCp", () => {
                    if ((typeof BSS_B2B.cpRuleChoice == "undefined" || BSS_B2B.cpRuleChoice.length == 0)) {
                        rowPrice.innerHTML = `${(variant.compare_at_price && (variant.compare_at_price / 100) > variantsPrice) ? `<del>${BSS_BCP.formatMoney(variant.compare_at_price)}</del><br><true>${BSS_BCP.formatMoney(variantsPrice * 100)}</true>` : `${BSS_BCP.formatMoney(variantsPrice * 100)}`}`;
                    }
                    if (BSS_B2B.cpRuleChoice && BSS_B2B.cpRuleChoice.length) {
                        if (BSS_B2B.cpSettings.cpType === 2) {
                            if ((variant.price / 100) !== variantsPrice) {
                                generateElementCpPrice(rowPriceParent, rowPrice, row_dataCompare, variant, false, BSS_B2B, BSS_BCP);
                            }
                        }
                        if (BSS_B2B.cpSettings.cpType === 1) {
                            if (variant.compare_at_price && (variant.compare_at_price > variant.price)) {
                                generateElementCpPrice(rowPriceParent, rowPrice, row_dataCompare, variant, true, BSS_B2B, BSS_BCP);
                            } else {
                                generateElementCpPrice(rowPriceParent, rowPrice, row_dataCompare, variant, false, BSS_B2B, BSS_BCP);
                            }
                        }
                        rowPrice.innerHTML = `<span> ${BSS_BCP.formatMoney(variantsPrice * 100)} </span>`
                        rowPrice.style.color = `${BSS_B2B.cpSettings.price_applied_cp_color}`
                        doneCheckCp = true;
                    }
                })
                if (!doneCheckCp) {
                    rowPrice.innerHTML = `<span> ${BSS_BCP.formatMoney(variantsPrice * 100)} </span>`;
                }
            }
        }

        rowPriceParent.appendChild(rowPrice);
        itemVariant.appendChild(rowPriceParent);

        // Row quantity
        let rowBoxQuantity = document.createElement('div');
        rowBoxQuantity.style.width = '150px';

        if (variant.available) {
            let qtyGroup = document.createElement('div');
            let qtyBtnGroup = document.createElement('div');
            let decrementBtn = document.createElement('button');
            let inputQty = document.createElement('input');
            let incrementBtn = document.createElement('button');
            let inStock = document.createElement('p');

            qtyGroup.className = "qty-group"
            qtyBtnGroup.className = "number-input"
            decrementBtn.className = "spinner decrement";
            decrementBtn.innerHTML = "-";
            incrementBtn.className = "spinner increment";
            incrementBtn.innerHTML = "+";

            inputQty.id = variant.id;
            inputQty.setAttribute('type', 'text');
            inputQty.setAttribute('value', '0');

            decrementBtn.addEventListener('click', () => {
                decrementQuantity(inputQty)
            });
            inputQty.addEventListener("keyup", () => {
                inputQty.value = inputQty.value.replace(/[^\d]/, '');
            });
            inputQty.addEventListener('input', (e) => {
                enforceMinMax(e, variantsQuantity[variant.id], variantsPolicy[variant.id], variant.inventory_management);
            });
            incrementBtn.addEventListener('click', () => {
                incrementQuantity(inputQty, variantsQuantity[variant.id], variantsPolicy[variant.id], variant.inventory_management);
            });

            if (variantsPolicy[variant.id] != 'continue' && variant.inventory_management) {
                // Custom in stock 
                if ([1792].includes(BSS_BCP.storeId)) {
                    customInStock(BSS_BCP, inStock, translations);
                } else {
                    inStock.innerHTML = `${variantsQuantity[variant.id]} ${translations["vo_inStock"]}`;
                }
            } else {
                inStock.innerHTML = translations["vo_unlimited"];
            }

            qtyBtnGroup.appendChild(decrementBtn);
            qtyBtnGroup.appendChild(inputQty);
            qtyBtnGroup.appendChild(incrementBtn);
            qtyGroup.appendChild(qtyBtnGroup)
            qtyGroup.appendChild(inStock);
            rowBoxQuantity.appendChild(qtyGroup);
        } else {
            rowBoxQuantity.style.color = '#212529';
            rowBoxQuantity.style.textAlign = 'center';
            rowBoxQuantity.innerHTML = translations["vo_outOfStock"];
        }

        itemVariant.appendChild(rowBoxQuantity);
    })

    return table;
}

// CONCATENATED MODULE: ./src/js/src/vo/index.js




function initVO(shopData, BSS_BCP) {
    const productId = shopData.product.id;
    const productCollections = shopData.product_collections;
    const productTags = shopData.product.tags;
    const productVariants = shopData.product.variants;
    const translations = {};

    // Query selector button, form, ...
    const addToCartVoDefault = document.querySelectorAll(BSS_BCP.helper.addToCartVoDefault);

    BSS_BCP.vo.translation && BSS_BCP.vo.translation.map(item => {
        translations[item.key] = item.value;
    })

    /**
     * Append button buy it now
     * @param messageErrorEle
     * @param variants
     * @returns {void}
     */
    BSS_BCP.vo.appendBuyItNowBtn = function (msgError, variantsOrder) {
        const findBuyItNow = setInterval(() => {
            const buyItNowBtn = BSS_BCP.helper.getBuyItNowBtn();
            if (buyItNowBtn.length) {
                let event = new Event('bss_bcp_found_buy_it_now');
                window.dispatchEvent(event);
                clearInterval(findBuyItNow);
            }
        }, 200);
        setTimeout(() => {
            clearInterval(findBuyItNow);
        }, 4500);

        window.addEventListener('bss_bcp_found_buy_it_now', () => {
            const BSSVOCheckoutDefault = BSS_BCP.helper.getBuyItNowBtn();
            for (let i = 0; i < BSSVOCheckoutDefault.length; i++) {
                BSSVOCheckoutDefault[i].style.display = 'none';
            }
            setTimeout(() => {
                const btnBuyItNow = createBuyItNowBtn(msgError, BSSVOCheckoutDefault, translations);
                if (btnBuyItNow) {
                    variantsOrder.appendChild(btnBuyItNow);

                    // May be custom for store
                    const eleBuyItNow = document.querySelector('#bss-bcp-vo-buy-it-now').querySelector(BSS_BCP.helper.buyItNowtElements);
                    if (eleBuyItNow) {
                        eleBuyItNow.style.display = 'block';
                    }
                }
                // custom elements removal or styles
                if ([611].includes(BSS_BCP.storeId)) {
                    customAfterAppendBuyItNow(BSS_BCP);
                }
            }, 2000)
        })
    }

    BSS_BCP.vo.generateVariantsOrder = function () {
        let rulesApply = checkCustomerForVO(BSS_BCP, shopData.customer);
        rulesApply = checkProductForVO(rulesApply, productId, productCollections, productTags);
        const voRuleApply = rulesApply.length ? rulesApply[0] : false;
        if (voRuleApply) {
            const voAddToCartDefault = document.querySelectorAll(BSS_BCP.helper.addToCartVoDefault);
            const voProductFormDefault = document.querySelectorAll(BSS_BCP.helper.productFormVoDefault);
            const voProductPriceDefault = document.querySelectorAll(BSS_BCP.helper.productPriceVoDefault);
            const voVariantChoiceDefault = document.querySelectorAll(BSS_BCP.helper.variantChoiceVoDefault);
            const voProductQuantityDefault = document.querySelectorAll(BSS_BCP.helper.productQuantityVoDefault);
            const voCustomPosition = document.querySelectorAll("span.bss-b2b-customer-portal-variants-order");

            handleStyleElementForVo(voProductPriceDefault);
            handleStyleElementForVo(voAddToCartDefault);
            handleStyleElementForVo(voVariantChoiceDefault);
            handleStyleElementForVo(voProductQuantityDefault);

            const msgError = document.createElement('p');
            msgError.style.cssText = 'color: red; margin-top: 13px; margin-bottom: -8px;';

            const variantsOrder = document.createElement('div');
            const tableDiv = document.createElement('div');
            variantsOrder.className = "bss-b2b-variants-order";
            tableDiv.className = "bss-b2b-table-div";

            const dataTable = createTable(productVariants, productId, shopData, translations);
            const btnAddToCart = createAddToCartBtn(BSS_BCP, msgError, addToCartVoDefault, translations);

            variantsOrder.appendChild(tableDiv);
            tableDiv.appendChild(dataTable);
            variantsOrder.appendChild(msgError);
            variantsOrder.appendChild(btnAddToCart);
            BSS_BCP.vo.appendBuyItNowBtn(msgError, variantsOrder);

            if (voProductFormDefault.length) {
                for (let i = 0; i < voProductFormDefault.length; i++) {
                    voProductFormDefault[i].after(variantsOrder);
                }
            }
            if (voCustomPosition.length) {
                for (let i = 0; i < voCustomPosition.length; i++) {
                    voCustomPosition[i].after(variantsOrder);
                }
            }

            // Custom remove element
            if ([611].includes(BSS_BCP.storeId)) {
                customRemoveElement(BSS_BCP);
            }
        }
    }

    BSS_BCP.vo.generateVariantsOrder();
}
// CONCATENATED MODULE: ./src/js/src/index.js





function InitFunction() {
    var shopData = {};
    let getStoreData = document.querySelector('#bss-bcp-store-data');
    if (getStoreData) {
        shopData = JSON.parse(document.querySelector('#bss-bcp-store-data').innerHTML);
    }

    BSS_BCP.helper = {};
    helper(BSS_BCP);
    formatMoney(shopData, BSS_BCP);
    let isEnableQuote = BSS_BCP.isEnableQuote ? true : false;
    let isEnableNT = BSS_BCP.nt && BSS_BCP.nt.isEnable ? true : false;
    let isEnableVO = BSS_BCP.vo && BSS_BCP.vo.isEnable ? true : false;
    if (isEnableQuote) {
        BSS_BCP.quote = {};
        initQuote(shopData, BSS_BCP);
    }
    if (isEnableNT) {
        BSS_BCP.netterm = {};
        initNT(shopData, BSS_BCP);
    }
    if (isEnableVO && shopData.template === "product" && shopData.product.variants.length > 1) {
        initVO(shopData, BSS_BCP);
    }
}
InitFunction();


/***/ })
/******/ ]);